import React, { useState, useEffect, useCallback, useRef } from "react";
import TreeView from 'devextreme-react/tree-view';
import { useHistory } from "react-router-dom";
import * as PermissionsConstants from "../const/constants";
import * as ReduxOidc from "redux-oidc";
import configuration from "../configuration";
import axios from "axios";
import data from "../assets/apiRoutes.json";
import { useDispatch, connect } from "react-redux";
import { ABECASUSER_LOGIN_TYPE } from "../common/permissions";
import "./Sidebar.css";
import "./contextMenu.css";
import "./treeViewSidebar.css";
import { Fetch_Roles_Permissions, SET_TREEVIEW_VISIBLE_URLS, SET_REPORT_MENU } from "../redux/actions/receipt";
import { clearAllChatMessages, getAppSettings } from "../common/Utils";
import { clearAllSearchStates } from "../common/SearchStatePersistence";
import { extractUrlsFromTreeView } from "../home/utils/treeViewUrlExtractor";
import { MenuService, GetMenuOrder } from "../services/MenuService"; import ContextMenu from 'devextreme-react/context-menu';
import List from 'devextreme-react/list';
import service from './contextMenu.js';
import notify from 'devextreme/ui/notify';
import { LoadPanel } from 'devextreme-react/load-panel';
import ReportIcon from '../assets/reporticon.png';
import DashboardIcon from '../assets/dashboard.png';
import DockDoorIcon from '../assets/dockdoor.png';
import OrchardIcon from '../assets/orchard.png';
import OmIcon from '../assets/om.png';
import PtrIcon from '../assets/ptr.png';
import SodIcon from '../assets/sod.png';
import WmIcon from '../assets/wm.png';
import SecurityIcon from '../assets/SecurityIcon.png';
import ShortCutIcon from '../assets/shortcut.png';
import HomeIcon from '../assets/home_icon_menu.png';
import LogoutIcon from '../assets/log-out.png';
import ImportExportIcon from '../assets/import_export_icon.png';
import DashboardLiteIcon from '../assets/dashboard_lite_icon.png';
import UserIcon from '../assets/user.png';
import ScreenIcon from '../assets/screenIcon.png';
import TransactionIcon from '../assets/transaction.png';
import PreiodicIcon from '../assets/preiodic_task_icon.png';
import ReportTemplateIcon from '../assets/report_template.png';
import FolderIcon from '../assets/folderIcon1.png';
import { MenuNames } from '../enum/Enum';
import { parseShortcutsApiResponse } from "../common/shortcutsApi";
import { getReportMenuAll, leafKeyFromPath, overlayItemKey, synthLeafFromOverlay } from "../services/ReportGroupService";

const menuItems = service.getMenuItems();

// Union of the role-permission category arrays into a Set, for gating report groups/items.
const buildPermSet = (data, keys) => {
    const s = new Set();
    (keys || []).forEach((k) => {
        const arr = data && data[k];
        if (Array.isArray(arr)) arr.forEach((p) => s.add(p));
    });
    return s;
};
var menuShortcuts = [];

const TreeviewSidebar = (props) => {

    var accessToken = props.oidc.user.access_token;
    const dispatch = useDispatch();
    const menueService = new MenuService();
    const menuList = [
        MenuNames.Home,
        MenuNames.AdvancedReportingTool,
        MenuNames.DockDoorScheduler,
        MenuNames.ImportExportData,
        MenuNames.SowOrderDatabase,
        MenuNames.PullTagReview,
        MenuNames.DashboardLite,
        MenuNames.OrderManagement,
        MenuNames.OrchardManagement,
        MenuNames.WarehouseManagement,
        MenuNames.Dashboard,
        MenuNames.InventoryManagement,
        MenuNames.RadioFrequency,
        MenuNames.PurchaseOrderManagement,
        MenuNames.ElectronicFrequency,
        MenuNames.AccountingModule
    ];

    /*
    const [sodMainMenu, setSodMainMenu] = useState([]);
    const [wmMainMenu, setWMMainMenu] = useState([]);
    const [securityMainMenu, setSecurityMainMenu] = useState([]);
    const [ddMainMenu, setDDMainMenu] = useState([]);
    const [tmMainMenu, setTMMainMenu] = useState([]);
    */
    const contextMenuRef = useRef(null);
    const treeViewRef = useRef(null);
    // DB-driven report menus keyed by module code (populated before role-permission build).
    const reportMenusRef = useRef({});
    const [selectedTreeItem, setSelectedTreeItem] = useState(null);
    const [shortcuts, setShortcuts] = useState([]);
    const [loadingSidebar, setLoadingSidebar] = useState(true);
    const position = { of: '#sidebarContent' };

    // Function to get restricted pages from app settings
    const getRestrictedPages = () => {
        try {
            const appSettings = getAppSettings();
            if (appSettings && appSettings.RestrictedPages && Array.isArray(appSettings.RestrictedPages)) {
                return appSettings.RestrictedPages.map(page => page.value);
            }
        } catch (error) {
            console.error("Error getting restricted pages:", error);
        }
        return [];
    };

    // Recursive function to filter out restricted pages from tree view
    const filterRestrictedPages = (items) => {
        if (!items || !Array.isArray(items)) {
            return items;
        }

        const restrictedPaths = getRestrictedPages();
        if (restrictedPaths.length === 0) {
            return items;
        }

        return items
            .map(item => {
                // If item has a path and it's restricted, exclude it
                if (item.path && restrictedPaths.includes(item.path)) {
                    return null;
                }

                // Recursively filter child items
                if (item.items && Array.isArray(item.items) && item.items.length > 0) {
                    const filteredItems = filterRestrictedPages(item.items);
                    // Only include parent if it has children after filtering (or if it has no path itself)
                    if (filteredItems.length > 0 || !item.path) {
                        return {
                            ...item,
                            items: filteredItems
                        };
                    }
                    return null;
                }

                // Include item if it doesn't have a restricted path
                return item;
            })
            .filter(item => item !== null);
    };

    const [treeviewData, setTreeviewData] = useState([{
        id: "home_1",
        text: "Home",
        icon: window._env_.REACT_APP_MENU_USE_PNG ? HomeIcon : 'fa fa-home',
        orderNumber: GetMenuOrder(menuList, MenuNames.Home),
        expanded: false,
        path: "/home",
        items: []
    },
    {
        id: "shortcuts_1",
        text: "Shortcuts",
        icon: window._env_.REACT_APP_MENU_USE_PNG ? ShortCutIcon : 'fa fa-folder',
        orderNumber: 2,
        expanded: false,
        items: []
    },
    // {
    //     id: "shortcuts_2",
    //     text: "Dynamic From",
    //     expanded: false,
    //     icon: 'fa fa-folder',
    //     path: "/om/dynamic-form",
    //     orderNumber: 3,
    //     //permission: PermissionsConstants.OMInventory,
    // },
    {
        id: "logout_1",
        text: "Logout",
        tooltip: "Logout",
        icon: window._env_.REACT_APP_MENU_USE_PNG ? LogoutIcon : 'fa fa-sign-out',
        orderNumber: 100,
        expanded: false,
        path: "/",
        items: []
    }
    ]);
    const history = useHistory();
    const treeViewItemContextMenu = useCallback((e) => {
        let isItFolder = e.itemData.items ? true : false;
        if (isItFolder) {
            contextMenuRef.current.instance().option('items[0].visible', false);
            contextMenuRef.current.instance().option('items[1].visible', false);
            return;
        }
        var item = e.itemData;
        setSelectedTreeItem(item);
        let isFromShortcut = e?.node?.parent?.key === "shortcuts_1"
        contextMenuRef.current.instance().option('items[0].visible', !isFromShortcut);
        contextMenuRef.current.instance().option('items[1].visible', isFromShortcut);

    }, []);
    const isItemAlreadyExists = (newItem) => {
        return shortcuts.some(item => {
            return item.text === newItem.text && item.path === newItem.path;
        });
    };

    const contextMenuItemClick = useCallback(
        async (e) => {
            var linkType = e.itemData.id;
            let tempSelectedTreeItem = [...shortcuts];
            if (linkType === "createShortcut") {
                let itemAlreadyadded = isItemAlreadyExists(selectedTreeItem);
                if (itemAlreadyadded) {
                    notify(
                        {
                            message: "Shortcut already exists",
                            width: 100,
                        },
                        'error',
                        3000,
                    );
                    return;
                }
                tempSelectedTreeItem.push(selectedTreeItem);
                tempSelectedTreeItem = addUniqueIdsToItems(tempSelectedTreeItem);
            }
            else if (linkType === "deleteShortcut") {
                tempSelectedTreeItem = tempSelectedTreeItem.filter(item => item.id !== selectedTreeItem.id);
            }
            let request = {
                shortcut: JSON.stringify(tempSelectedTreeItem),
            };
            const response = await axios.post(`${window._env_.REACT_APP_APIS}/${data.Shortcuts.UpdateShortcuts}`,
                request
                , {
                    headers: {
                        "Content-Type": "application/json",
                        access_token: accessToken,
                        Authorization: `Bearer ${accessToken}`,
                    },
                }
            );
            if (response.data) {
                notify(
                    {
                        message: linkType === "createShortcut" ? "Shorcut added successfully" : "Shorcut removed successfully",
                        width: 100,
                    },
                    'success',
                    3000,
                );
                setShortcuts(tempSelectedTreeItem);
            }
        });
    var rfSideBarLinks = [
        {
            id: 'rf_1_1',
            text: 'Periodic Tasks',
            icon: 'fa fa-folder',
            expanded: false,
            path: "/rf/periodictasks",
            items: [
            ]
        }
    ];
    var efSideBarLinks = [

    ];
    var acSideBarLinks = [

    ];
    // Bulk-defined simple modules. Each entry gets an empty sideBarLinks array;
    // Dashboard / Dashboard Lite / Art Reports parents are attached automatically by the registry.
    // Add a real `permission`-bearing static link to `sideBarLinks` here if/when one is needed.
    const simpleModuleDefinitions = [
        { code: 'AP', displayName: 'Accounts Payable',                menuNameKey: 'AccountsPayable',           sideBarLinks: [] },
        // AR report permissions (e.g. AgingReport) are carried in the shared 'Reports' category.
        { code: 'AR', displayName: 'Accounts Receivable',             menuNameKey: 'AccountsReceivable',        sideBarLinks: [
            {
                id: 'ar_1_1',
                text: 'Credit/Collections Follow-up',
                icon: window._env_.REACT_APP_MENU_USE_PNG ? ScreenIcon : 'icon fa fa-folder',
                path: "/ar/collections/follow-up",
                permission: PermissionsConstants.ARCollectionCredit,
            },
        ], reportPermKeys: ['ARReports', 'ARMenu', 'Reports'] },
        { code: 'CA', displayName: 'Cost Accounting',                 menuNameKey: 'CostAccounting',            sideBarLinks: [] },
        { code: 'CM', displayName: 'Contact Management',              menuNameKey: 'ContactManagement',         sideBarLinks: [] },
        { code: 'ED', displayName: 'Electronic Data Interchange',     menuNameKey: 'ElectronicDataInterchange', sideBarLinks: [] },
        { code: 'FA', displayName: 'Fund Accounting',                 menuNameKey: 'FundAccounting',            sideBarLinks: [] },
        // T20260930.0001 - Driver Bill of Lading Capture. Two separate grants, never one: the business
        // requirement is that a driver login reaches Send BOL and nothing else, so a driver role must be
        // able to carry the first of these without the second.
        { code: 'FM', displayName: 'Freight Management',              menuNameKey: 'FreightManagement',         sideBarLinks: [
            {
                id: 'fm_1_1',
                text: 'Send BOL',
                icon: window._env_.REACT_APP_MENU_USE_PNG ? ScreenIcon : 'icon fa fa-camera',
                path: "/fm/freight-bills/send-bol",
                permission: PermissionsConstants.FMMenuViewSendBOL,
            },
            {
                id: 'fm_1_2',
                text: 'Driver BOLs',
                icon: window._env_.REACT_APP_MENU_USE_PNG ? ScreenIcon : 'icon fa fa-file-text-o',
                path: "/fm/freight-bills/driver-bols",
                permission: PermissionsConstants.FMMenuViewDriverBOLs,
            },
        ] },
        { code: 'GL', displayName: 'General Ledger',                  menuNameKey: 'GeneralLedger',             sideBarLinks: [] },
        { code: 'HR', displayName: 'Human Resources',                 menuNameKey: 'HumanResources',            sideBarLinks: [] },
        { code: 'ID', displayName: 'Identity (Names and Addresses)',  menuNameKey: 'Identity',                  sideBarLinks: [] },
        { code: 'PI', displayName: 'Parts Inventory',                 menuNameKey: 'PartsInventory',            sideBarLinks: [] },
        { code: 'PM', displayName: 'Production Management',           menuNameKey: 'ProductionManagement',      sideBarLinks: [] },
        { code: 'PR', displayName: 'Payroll',                         menuNameKey: 'Payroll',                   sideBarLinks: [] },
        { code: 'RM', displayName: 'Relationship Management',         menuNameKey: 'RelationshipManagement',    sideBarLinks: [] },
        { code: 'RT', displayName: 'Rate Tariffs',                    menuNameKey: 'RateTariffs',               sideBarLinks: [] },
        { code: 'SI', displayName: 'Supplies Inventory',              menuNameKey: 'SuppliesInventory',         sideBarLinks: [] },
        { code: 'SM', displayName: 'Service Management',              menuNameKey: 'ServiceManagement',         sideBarLinks: [] },
        { code: 'SP', displayName: 'Settlements Processing',          menuNameKey: 'SettlementsProcessing',     sideBarLinks: [] },
    ];
    var wmSideBarLinks = [
        {
            id: 'wmSideBarLinks_0_3',
            text: 'Transactions',
            icon: 'fa fa-folder',
            expanded: false,
            path: "/wm/Transaction",
            
            items: [
            ]
        },
        {
            id: 'wmSideBarLinks_0_8',
            text: 'Reports',
            icon: 'fa fa-folder',
            expanded: false,
           
            items: []
        },
        {
            id: 'wmSideBarLinks_0_7',
            text: 'Codes',
            icon: 'fa fa-folder',
            expanded: false,
            
            items: []
        },
        {
            id: 'wmSideBarLinks_1_3',
            text: 'Data Profiles',
            icon: 'fa fa-folder',
            expanded: false,
           
            items: []
        },
        {
            id: 'wmSideBarLinks_1_4',
            text: 'Setup',
            icon: 'fa fa-folder',
            expanded: false,
            
            items: []
        }
    ];
    var wmLocationTrackingIndex = wmSideBarLinks.push({
        id: 'wmSideBarLinks_0_4',
        expanded: false,
        icon: 'fa fa-folder',
        text: "Location Tracking",

        items: []
    }
    );

    var wmLaborTrackingIndex = wmSideBarLinks.push({
        id: 'wmSideBarLinks_0_9',
        expanded: false,
        icon: 'fa fa-folder',
        text: "Labor Tracking",
        items: []
    }
    );

    var wmCustomerTrackingIndex = wmSideBarLinks.push({
        id: 'wmSideBarLinks_0_1',
        expanded: false,
        icon: 'fa fa-folder',
        text: "Customer",
        
        items: [],
    }
    );

    var wmCarrierTrackingIndex = wmSideBarLinks.push({
        id: 'wmSideBarLinks_0_2',
        expanded: false,
        icon: 'fa fa-folder',
        text: "Carrier",
        
        items: [],
    }
    );
    var wmPhysicalCountTrackingIndex = wmSideBarLinks.push({
        id: 'wmSideBarLinks_0_5',
        expanded: false,
        icon: 'fa fa-folder',
        text: "Physical Count",
        
        items: [],
    }
    );
    var wmChargesTrackingIndex = wmSideBarLinks.push({
        id: 'wmSideBarLinks_0_5a',
        expanded: false,
        icon: 'fa fa-folder',
        text: "Charges",
       
        items: [],
    }
    );
    // Delivery Management — the WM half of the FM hand-off, matching the OM module's own
    // "Delivery Management" folder (om/transaction/deliveryManagement).
    var wmDeliveryManagementIndex = wmSideBarLinks.push({
        id: 'wmSideBarLinks_0_5b',
        expanded: false,
        icon: 'fa fa-folder',
        text: "Delivery Management",

        items: [],
    }
    );
    var wmInvoicingTrackingIndex = wmSideBarLinks.push({
        id: 'wmSideBarLinks_0_6',
        expanded: false,
        icon: 'fa fa-folder',
        text: "Invoicing",
       
        items: [],
    }
    );
    var importSection = {
        id: 'wmSideBarLinks_1_2',
        icon: 'fa fa-folder',
        text: "Periodic Tasks",
        expanded: false,
        
        items: []
    };

    if (props.oidc.user.profile.hasOwnProperty("WMIMPORTFILES") && props.oidc.user.profile.WMIMPORTFILES == "Y") {

        importSection.items.push(
            {
                id: '1_3_1',
                text: "Import Data",
                expanded: false,
                icon: window._env_.REACT_APP_MENU_USE_PNG ? ScreenIcon : 'icon icon-ag-report',
                path: "/wm/importdata",
                permission: null
            });

    }

    wmSideBarLinks.push(importSection);

    var customizeSettings =
    {
        id: 'wmSideBarLinks_1_5',
        expanded: false,
        icon: 'fa fa-folder',
        text: "Setup",
        items: []
    }
    wmSideBarLinks.push(customizeSettings);


    var securitySideBarLinks = [
        {
            id: "security_7_1",
            text: "Change Password",
            icon: window._env_.REACT_APP_MENU_USE_PNG ? ScreenIcon : 'icon fa fa-key',
            path: "/security/change-password",
            permission: null,
        },

        {
            id: "security_7_4",
            text: "2F Authentication",
            icon: window._env_.REACT_APP_MENU_USE_PNG ? ScreenIcon : 'fa fa-user',
            path: "/security/two-factor-settings",
            permission: null,
        },
        {
            id: "security_7_report_groups",
            text: "Report Groups",
            icon: window._env_.REACT_APP_MENU_USE_PNG ? ReportTemplateIcon : 'icon icon-ag-report',
            path: "/security/report-groups",
            permission: PermissionsConstants.ReportGroup,
        }
    ];
    var xmSideBarLinks = [
        {
            id: "xm_7_1",
            text: "XM Monitor",
            icon: window._env_.REACT_APP_MENU_USE_PNG ? ScreenIcon : 'icon fa fa-television',
            path: "/xm/xm-monitor",
            permission: PermissionsConstants.ViewXmMonitor,
        },

    ];
    var poSideBarLinks = [
        {
            id: "po_7_1",
            text: "Transactions",
            icon: window._env_.REACT_APP_MENU_USE_PNG ? ScreenIcon : 'icon fa fa-folder',
            expanded: false,
            items: [
                {
                    id: "po_7_1_1_1",
                    text: "Generate Item Reorder Records",
                    icon: window._env_.REACT_APP_MENU_USE_PNG ? ScreenIcon : 'icon fa fa-folder',
                    path: "/po/transactions/requisitions/generate-item-reorder-records",
                    permission: PermissionsConstants.POGenerateRequisition,
                },
            ],
        },
    ];
        var TaskAgentSideBarLinks = [
        {
            id: "task_9_1",
            text: "Task Queue",
            icon: window._env_.REACT_APP_MENU_USE_PNG ? ScreenIcon : 'icon fa fa-television',
            path: "/ta/task-queue-list",
            permission: PermissionsConstants.TaskQueue,
        },

    ];
    var sodSideBarLinks = [
        {
            id: '2_1',
            text: 'PU Processing',
            icon: 'fa fa-folder',
            expanded: false,

            items: [
                {
                    id: '2_1_1',
                    text: 'Update',
                    icon: window._env_.REACT_APP_MENU_USE_PNG ? ScreenIcon : 'icon icon-ag-update',
                    path: "/so/update",
                    permission: PermissionsConstants.SodUpdateOrdersScreen
                },

                {
                    id: '2_1_2',
                    text: 'Review Records',
                    icon: window._env_.REACT_APP_MENU_USE_PNG ? ScreenIcon : 'icon icon-ag-review',
                    expanded: false,
                    path: "/so/review-records",
                    permission: PermissionsConstants.SodReviewRecordsScreen

                }, {
                    id: '2_1_3',
                    text: 'Lot Select',
                    icon: window._env_.REACT_APP_MENU_USE_PNG ? ScreenIcon : 'icon icon-ag-lot-select',
                    expanded: false,
                    path: "/so/lot-select",
                    permission: PermissionsConstants.SodLotSelectScreen

                },
                {
                    id: '2_1_4',
                    text: 'Master Records',
                    icon: window._env_.REACT_APP_MENU_USE_PNG ? ScreenIcon : 'icon icon-ag-cart-1',
                    expanded: false,
                    path: "/so/master-records",
                    permission: PermissionsConstants.SodLotMasterRecordsScreen

                },
                {
                    id: '2_1_5',
                    text: 'Pull Order',
                    icon: window._env_.REACT_APP_MENU_USE_PNG ? ScreenIcon : 'icon icon-ag-pull-order',
                    expanded: false,
                    path: "/so/pullorder",
                    permission: PermissionsConstants.SodPullOrderScreen

                },
                {
                    id: "2_1_6",
                    text: "Select Dry Strat",
                    icon: window._env_.REACT_APP_MENU_USE_PNG ? ScreenIcon : 'icon icon-ag-dry-strat',
                    path: "/so/dry-strat",
                    permission: PermissionsConstants.SodSelectDryStratScreen
                },
                {
                    id: "2_1_7",
                    text: "Strat Complete",
                    icon: window._env_.REACT_APP_MENU_USE_PNG ? ScreenIcon : 'icon icon-ag-strat-complete',
                    path: "/so/strat-complete",
                    permission: PermissionsConstants.SodStratCompleteScreen
                },
                {
                    id: '2_1_8',
                    text: 'Ship',
                    icon: window._env_.REACT_APP_MENU_USE_PNG ? ScreenIcon : 'icon icon-ag-ship',
                    expanded: false,
                    path: "/so/ship-complete",
                    permission: PermissionsConstants.SodShipCompleteScreen

                }
            ],

        },
        {
            id: '2_2',
            text: 'Calculators',
            icon: 'fa fa-folder',
            items: [{
                id: '2_2_1',
                text: 'Bare Root',
                icon: window._env_.REACT_APP_MENU_USE_PNG ? ScreenIcon : 'icon icon-ag-roots',
                path: "/so/bare-root",
                permission: PermissionsConstants.SodBareRootCalculatorScreen

            }, {
                id: '2_2_2',
                text: 'Plugs',
                icon: window._env_.REACT_APP_MENU_USE_PNG ? ScreenIcon : 'icon icon-ag-plugs',
                path: "/so/plugs",
                permission: PermissionsConstants.SodPlugsCalculatorScreen

            }],

        },
        {
            id: '2_3',
            text: 'Maintenance',
            icon: 'fa fa-folder',
            items: [{
                id: '2_3_1',
                text: 'Add Seed Lot',
                icon: window._env_.REACT_APP_MENU_USE_PNG ? ScreenIcon : 'icon icon-ag-seed-inventory',
                path: "/so/add-seedlot",
                permission: PermissionsConstants.SodAddSeedLotsScreen

            }, {
                id: '2_3_2',
                text: 'Edit Seed Inventory',
                icon: window._env_.REACT_APP_MENU_USE_PNG ? ScreenIcon : 'icon icon-ag-seed-inventory',
                path: "/so/edit-seed",
                permission: PermissionsConstants.SodEditSeedInventoryScreen

            }, {
                id: '2_3_3',
                text: 'Export to Abecas',
                icon: window._env_.REACT_APP_MENU_USE_PNG ? ScreenIcon : 'icon icon-ag-export', 
                path: "/so/export",
                permission: ''
            },
            {
                id: '2_3_4',
                text: 'Edit Tables',
                icon: window._env_.REACT_APP_MENU_USE_PNG ? ScreenIcon : 'icon icon-ag-edit-tables',  
                path: "/so/edit-tables",
                permission: PermissionsConstants.SodEditTablesScreen

            },
            {
                id: '2_3_5',
                text: 'Archive Data',
                icon: window._env_.REACT_APP_MENU_USE_PNG ? ScreenIcon : 'icon icon-ag-archive',   
                path: "/so/archive-data",
                permission: ''
            },

            ],

        },
        {
            id: '2_4',
            text: 'Reports',
            icon: 'fa fa-folder',
            items: [
            {
                id: '2_4_17',
                text: 'Bag Tags Report',
                icon: window._env_.REACT_APP_MENU_USE_PNG ? ReportTemplateIcon : 'icon icon-ag-report',
                path: "/so/reports/bagtags",
                permission: PermissionsConstants.SodBagTagsReport

            },
            {
                id: '2_4_18',
                text: 'Pre Cut Label Bag Tag Report',
                icon: window._env_.REACT_APP_MENU_USE_PNG ? ReportTemplateIcon : 'icon icon-ag-report',
                path: "/so/reports/cutlotlabelbagtags",
                permission: PermissionsConstants.SodCutLotLabelBagTagsReport

            },
            {
                id: '2_4_19',
                text: 'Manual Bag Tags Report',
                icon: window._env_.REACT_APP_MENU_USE_PNG ? ReportTemplateIcon : 'icon icon-ag-report',
                path: "/so/reports/manualbagtags",
                permission: PermissionsConstants.SodManualBagTagsReport

            },

            ],
        }
    ];

    var tmSideBarLinks = [
        {
            id: "tm_7_1",
            text: "Transactions",
            icon: 'fa fa-folder',
            items: [
                {
                    id: "7_1_1",
                    text: "Inspection Sheet",
                    icon: window._env_.REACT_APP_MENU_USE_PNG ? ScreenIcon : 'icon icon-ag-report',  
                    path: "/tm/transactions/inspection",
                    permission: PermissionsConstants.TMMenuViewNewInspection,
                },
                ,
                {
                    id: "7_1_2",
                    text: "Import Inspections",
                    icon: window._env_.REACT_APP_MENU_USE_PNG ? ScreenIcon : 'icon icon-ag-report',  
                    path: "/tm/transactions/importinspections",
                    permission: PermissionsConstants.TMMenuViewImportInspections
                },
                {
                    id: "7_1_3",
                    text: "Export Inspections",
                    icon: window._env_.REACT_APP_MENU_USE_PNG ? ScreenIcon : 'icon icon-ag-report',  
                    path: "/tm/transactions/exportinspections",
                    permission: PermissionsConstants.TMMenuViewExportInspections
                },
                {
                    id: "7_1_4",
                    text: "Print Asset Tags",
                    icon: window._env_.REACT_APP_MENU_USE_PNG ? ScreenIcon : 'icon icon-ag-report',  
                    path: "/tm/transactions/printassettags",
                    permission: PermissionsConstants.TMMenuViewPrintAssetTags,
                },
                {
                    id: "7_1_5",
                    text: "Inspection Types",
                    icon: window._env_.REACT_APP_MENU_USE_PNG ? ScreenIcon : 'icon icon-ag-report',  
                    path: "/tm/transactions/inspectiontypes",
                    permission: PermissionsConstants.TMMenuViewInspectionTypes
                }

            ]
        },
        {
            id: "tm_7_2",
            text: "Codes",
            icon: 'fa fa-folder',
            items: [
                {
                    id: "7_2_1",
                    text: "Orchard Codes",
                    icon: window._env_.REACT_APP_MENU_USE_PNG ? ScreenIcon : 'icon icon-ag-report',  
                    path: "/tm/codes/orchard-codes",
                    permission: PermissionsConstants.TMMenuViewOrchardCodes,
                },
                {
                    id: "7_2_2",
                    text: "Block Codes",
                    icon: window._env_.REACT_APP_MENU_USE_PNG ? ScreenIcon : 'icon icon-ag-report',  
                    path: "/tm/codes/block-codes",
                    permission: PermissionsConstants.TMMenuViewBlockCodes,
                },
                {
                    id: "7_2_3",
                    text: "Location Codes",
                    icon: window._env_.REACT_APP_MENU_USE_PNG ? ScreenIcon : 'icon icon-ag-report',  
                    path: "/tm/codes/location-codes",
                    permission: PermissionsConstants.TMMenuViewLocationCodes,
                },
                {
                    id: "7_2_4",
                    text: "Ramet Codes",
                    icon: window._env_.REACT_APP_MENU_USE_PNG ? ScreenIcon : 'icon icon-ag-report',  
                    path: "/tm/codes/ramet-codes",
                    permission: PermissionsConstants.TMMenuViewRametCodes,
                }
            ]
        },
        {
            id: "7_3",
            text: "Reports",
            icon: 'fa fa-folder',
            items: [
                {
                    id: "7_3_1",
                    text: "Inventory Reports",
                    icon: window._env_.REACT_APP_MENU_USE_PNG ? ReportTemplateIcon : 'icon icon-ag-report',
                    path: "/tm/reports/inventoryreports",
                    permission: PermissionsConstants.TMMenuViewInventoryReports
                }
            ]
        }
    ];

    var atSideBarLinks = [
        {
            id: "at_8_1",
            text: "Advanced Reporting Tool",
            icon: window._env_.REACT_APP_MENU_USE_PNG ? ScreenIcon : 'icon icon-ag-report', 
            path: "/at/advancedreporttool",
            permission: PermissionsConstants.ATMenuViewAdvancedReportTool,
        },
        {
            id: 'at_8_2',
            text: 'Configuration',
            icon: window._env_.REACT_APP_MENU_USE_PNG ? ScreenIcon : 'icon icon-ag-report', 
            expanded: false,
            path: "/at/configuration",
            permission: PermissionsConstants.ATMenuViewARTConfiguration

        }
    ]

    var dockdoorSideBarLinks = [
        {
            id: "dd_1_1",
            text: "Selection",
            icon: window._env_.REACT_APP_MENU_USE_PNG ? ScreenIcon : 'icon icon-ag-report', 
            path: "/wm/dockdoorselection",
            permission: PermissionsConstants.DockDoorViewSelectionScreen,
        },
        {
            id: "dd_1_2",
            text: "Status",
            icon: window._env_.REACT_APP_MENU_USE_PNG ? ScreenIcon : 'icon icon-ag-report', 
            path: "/wm/dockdoorstatus",
            permission: PermissionsConstants.DockDoorViewStatusScreen,
        }
    ]

    const [currentItem, setCurrentItem] = React.useState(treeviewData[0]);
    function delete_cookie(name) {
        document.cookie = name + '=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
    }
    const selectItem = (e) => {
        if (props.sidebarMinimized) {
            props.minimizeSidebar();
        }
        if (e.itemData?.id === "logout_1") {
            logoutUser(e);
            return;
        }
        history.push(e.itemData?.path);
        setCurrentItem({ currentItem: { ...e.itemData } })
    }
    var IM_SideBarLinks = [
        {
            id: 'im_transaction_1_1',
            text: 'Transactions',
            icon: 'fa fa-folder',
            expanded: false,
            items: [{
                id: "im_transaction_1_2",
                text: "Transaction Entry Form",
                expanded: false,
                icon: window._env_.REACT_APP_MENU_USE_PNG ? ScreenIcon : 'icon icon-ag-update',
                path: "/im/TransactionEntryForm/" + PermissionsConstants.IMTransactionEntryForm,
                permission: PermissionsConstants.IMTransactionEntryForm,
            },
            {
                id: "im_transaction_1_2_1",
                text: "Enter Transaction",
                expanded: false,
                icon: window._env_.REACT_APP_MENU_USE_PNG ? ScreenIcon : 'icon icon-ag-update',
                path: "/im/EnterTransaction/" + PermissionsConstants.IMEnterTransaction,
                permission: PermissionsConstants.IMEnterTransaction,
            },
            {
                id: "im_transaction_1_3",
                text: "Enter Location Codes",
                expanded: false,
                icon: window._env_.REACT_APP_MENU_USE_PNG ? ScreenIcon : 'icon icon-ag-history',
                path: "/im/codes/location-data-entry",
                permission: PermissionsConstants.IMLocationDataEntry,
            },
            {
                id: "im_transaction_1_4",
                text: "Item Management",
                expanded: false,
                icon: window._env_.REACT_APP_MENU_USE_PNG ? ScreenIcon : 'icon icon-ag-update',
                path: "/im/itemManagement/" + PermissionsConstants.IMItemManagement,
                permission: PermissionsConstants.IMItemManagement,
            }

            ]
        },
        {
            id: 'im_reports',
            text: 'Reports',
            icon: 'fa fa-folder',
            expanded: false,
            items: []
        }
    ]
    var OMSideBarLinks = [
        {
            id: 'om_customer_7_1',
            text: 'Customer',
            icon: 'fa fa-folder',
            expanded: false,
            items: [{
                id: "om_customer_7_1_1",
                text: "Transactions",
                expanded: false,
                icon: window._env_.REACT_APP_MENU_USE_PNG ? ScreenIcon : 'icon icon-ag-update',
                path: "/om/transaction",
                permission: PermissionsConstants.OMTransaction,
            },
            {
                id: "om_customer_7_1_2",
                text: "History",
                expanded: false,
                icon: window._env_.REACT_APP_MENU_USE_PNG ? ScreenIcon : 'icon icon-ag-history', 
                path: "/om/history",
                permission: PermissionsConstants.OMTransactionHistory,
            }, {
                id: "om_customer_7_1_3",
                text: "Inventory Items",
                expanded: false,
                icon: window._env_.REACT_APP_MENU_USE_PNG ? ScreenIcon : 'icon icon-ag-seed-inventory', 
                path: "/om/Inventory",
                permission: PermissionsConstants.OMInventory,
            },
        ]
    },
        {
            id: 'om_transaction_7_1',
            text: 'Transactions',
            icon: 'fa fa-folder',
            expanded: false,
            // Grouped into the same sub-folders (and the same order) as the legacy
            // Abecas menu: Sales Orders => Processing => Delivery Management =>
            // Sales Commissions => Commit Transactions => EDI Processing.
            // Sales Commissions has no web screen yet, so it is not declared here;
            // empty folders are dropped by filterOMSidebarNestedItems anyway.
            items: [
            {
                id: 'om_transaction_7_1_sales_orders',
                text: 'Sales Orders',
                icon: 'fa fa-folder',
                expanded: false,
                permission: null,
                items: [
                {
                    id: "om_transaction_7_1_7",
                    text: "Sales Order Management",
                    expanded: false,
                    icon: window._env_.REACT_APP_MENU_USE_PNG ? ScreenIcon : 'icon icon-ag-report',
                    path: "/om/SalesOrderManagement",
                    permission: PermissionsConstants.SalesOrderManagement,
                },
                {
                    id: "om_transaction_7_1_5",
                    text: "Sales Order Data Entry",
                    expanded: false,
                    icon: window._env_.REACT_APP_MENU_USE_PNG ? ScreenIcon : 'icon icon-ag-transaction',
                    path: "/om/transactions/salesorders/salesorder-data-entry",
                    permission: PermissionsConstants.SalesOrderDataEntry,
                }
                ]
            },
            {
                id: 'om_transaction_7_1_processing',
                text: 'Processing',
                icon: 'fa fa-folder',
                expanded: false,
                permission: null,
                items: [
                {
                    id: 'om_transaction_7_1_6',
                    text: "Update Order Stage",
                    expanded: false,
                    icon: window._env_.REACT_APP_MENU_USE_PNG ? ScreenIcon : 'icon icon-ag-report',
                    path: "/om/update-order-stage",
                    permission: PermissionsConstants.OMUpdateOrderStage,
                },
                {
                    id: "om_transaction_7_1_8",
                    text: "Replicate Orders",
                    expanded: false,
                    icon: window._env_.REACT_APP_MENU_USE_PNG ? ScreenIcon : 'icon icon-ag-report',
                    path: "/om/replicateomtransaction",
                    permission: PermissionsConstants.OMReplicateTransaction,
                },
                {
                    id: 'om_transaction_7_1_10',
                    text: "Update Price On Orders",
                    expanded: false,
                    icon: window._env_.REACT_APP_MENU_USE_PNG ? ScreenIcon : 'icon icon-ag-report',
                    path: "/om/update-price",
                    permission: PermissionsConstants.OMUpdatePrice,
                },
                {
                    id: "om_transaction_7_1_9",
                    text: "Allocate Available Quantities",
                    expanded: false,
                    icon: window._env_.REACT_APP_MENU_USE_PNG ? ScreenIcon : 'icon icon-ag-report',
                    path: "/om/AllocateAvailableQuantities",
                    permission: PermissionsConstants.AllocateAvailableQuantities,
                },
                {
                    id: "om_transaction_7_1_15",
                    text: "Generate PO Drop-Ship Orders",
                    expanded: false,
                    icon: window._env_.REACT_APP_MENU_USE_PNG ? ScreenIcon : 'icon icon-ag-transaction',
                    path: "/om/transactions/processing/generate-po-drop-ship-orders",
                    permission: PermissionsConstants.OMGeneratePODropShipOrders,
                },
                {
                    id: 'update_order_detail_lot_7_1_12',
                    text: "Update Order Detail Lot",
                    expanded: false,
                    icon: window._env_.REACT_APP_MENU_USE_PNG ? ScreenIcon : 'icon icon-ag-report',
                    path: "/om/update-order-detail-lot",
                    permission: PermissionsConstants.OMUpdateOrderDetailLot,
                },
                {
                    // Not in the legacy OM => Transactions menu; grouped under
                    // Processing as the closest match.
                    id: 'om_generate_count_records_7_1_11',
                    text: "Generate Count Records",
                    expanded: false,
                    icon: window._env_.REACT_APP_MENU_USE_PNG ? ScreenIcon : 'icon icon-ag-report',
                    path: "/om/genneratecountrecords",
                    permission: PermissionsConstants.GeneratePhysicalInventoryCount,
                },
                {
                    // Legacy IMD0086. The kit data it rebuilds is IM's (the API route is
                    // api/im/KitUsageRecalculation and the service pins MODULE = 'IM'), but the
                    // screen is presented only from here, so it carries an /om/ route and a single
                    // OM-licensed permission - omSidebarItemAllowed searches the OM permission
                    // lists exclusively, so an IMMenu permission could never surface it.
                    id: 'om_recalculate_kit_usage_7_1_16',
                    text: "Recalculate Kit Usage Details",
                    expanded: false,
                    icon: window._env_.REACT_APP_MENU_USE_PNG ? ScreenIcon : 'icon icon-ag-report',
                    path: "/om/processes/recalculate-kit-usage",
                    permission: PermissionsConstants.OMRecalculateKitUsage,
                }
                ]
            },
            {
                id: 'om_transaction_7_1_delivery_management',
                text: 'Delivery Management',
                icon: 'fa fa-folder',
                expanded: false,
                permission: null,
                items: [
                {
                    id: "om_transaction_7_1_14",
                    text: "Transfer Deliveries To Dispatch",
                    expanded: false,
                    icon: window._env_.REACT_APP_MENU_USE_PNG ? ScreenIcon : 'icon icon-ag-transaction',
                    path: "/om/transactions/delivery-management/transfer-deliveries-to-dispatch",
                    permission: PermissionsConstants.OMTransferDeliveriesToDispatch,
                },
                {
                    // Legacy FMD0000. The Delphi shows this program under both FM and OM; the web
                    // reaches it from OM only, so it is gated by an OMMenu permission. Sits between
                    // Transfer Deliveries To Dispatch and Update Route/Trips on Orders, matching the Abecas
                    // menu order.
                    id: "om_transaction_7_1_17",
                    text: "Dispatch Management",
                    expanded: false,
                    icon: window._env_.REACT_APP_MENU_USE_PNG ? ScreenIcon : 'icon icon-ag-transaction',
                    path: "/om/transactions/delivery-management/dispatch-management",
                    permission: PermissionsConstants.OMMenuViewDispatchManagement,
                },
                {
                    id: "om_transaction_7_1_13",
                    text: "Update Route/Trips on Orders",
                    expanded: false,
                    icon: window._env_.REACT_APP_MENU_USE_PNG ? ScreenIcon : 'icon icon-ag-transaction',
                    path: "/om/transactions/delivery-management/list",
                    permission: PermissionsConstants.OMTrips,
                }
                ]
            },
            {
                id: 'om_transaction_7_1_commit_transactions',
                text: 'Commit Transactions',
                icon: 'fa fa-folder',
                expanded: false,
                permission: null,
                items: [
                {
                    id: "om_commit_transactions_7_1_4",
                    text: "Commit Transactions",
                    expanded: false,
                    icon: window._env_.REACT_APP_MENU_USE_PNG ? ScreenIcon : 'icon icon-ag-transaction',
                    path: "/om/omcommittransaction",
                    permission: PermissionsConstants.OMCommitTransaction,
                },
                {
                    id: "om_commit_transactions_7_1_5",
                    text: "Pre-Commit Transaction to AC",
                    expanded: false,
                    icon: window._env_.REACT_APP_MENU_USE_PNG ? ScreenIcon : 'icon icon-ag-transaction',
                    path: "/om/omprecommittransaction",
                    permission: PermissionsConstants.OMPreCommitTransaction,
                }
                ]
            },
            {
                id: 'om_transaction_7_1_edi_processing',
                text: 'EDI Processing',
                icon: 'fa fa-folder',
                expanded: false,
                permission: null,
                items: [
                {
                    id: "om_transaction_7_1_16",
                    text: "Export EDI Documents",
                    expanded: false,
                    icon: window._env_.REACT_APP_MENU_USE_PNG ? ScreenIcon : 'icon icon-ag-transaction',
                    path: "/om/transactions/export-edi-documents",
                    permission: PermissionsConstants.OMExportEdiDocuments,
                }
                ]
            }
            // ,{
            //     id: 'om_transaction_7_1_11',
            //     text: "Nurseries Inventory",
            //     expanded: false,
            //     icon: window._env_.REACT_APP_MENU_USE_PNG ? ScreenIcon : 'icon icon-ag-report',
            //     path: "/om/nurseries-inventory",
            //     permission: PermissionsConstants.OMUpdatePrice,
            // }
            ]
        },
        {
            id: 'om_reports_7_1',
            text: 'Reports',
            icon: 'fa fa-folder',
            expanded: false,
            items: []
        }
    ]
    ////dbl Menu Links
    const dashBoardMenuText = "Dashboard Lite";
    const dxDashBoardMenuText = "Dashboard";
    const artReportsMenuText = "Art Reports";

    // Generic registry: each module gets a Dashboard Lite, Dashboard, and Art Reports parent entry.
    // Add a new module here to give it all three menus automatically.
    // reportsNodeId points at the module's code-defined Reports node (a Reports node is
    // added automatically when absent); reportPermKeys are the role-permission categories
    // gating its DB-driven report groups (default: `${code}Reports` + `${code}Menu`).
    // treeId is the module's top-level treeview entry, used to re-attach the Reports
    // node when the module is visible but the node was filtered out as empty.
    const moduleMenuConfigs = [
        { code: 'AC', sideBarLinks: acSideBarLinks, treeId: 'ac_1' },
        { code: 'AT', sideBarLinks: atSideBarLinks, treeId: 'at_3' },
        { code: 'DD', sideBarLinks: dockdoorSideBarLinks, treeId: 'DD_1' },
        { code: 'EF', sideBarLinks: efSideBarLinks, treeId: 'ef_1' },
        { code: 'IM', sideBarLinks: IM_SideBarLinks, reportsNodeId: 'im_reports', treeId: 'im_1' },
        { code: 'OM', sideBarLinks: OMSideBarLinks, reportsNodeId: 'om_reports_7_1', treeId: 'om_1' },
        { code: 'PO', sideBarLinks: poSideBarLinks, treeId: 'po_1' },
        { code: 'RF', sideBarLinks: rfSideBarLinks, treeId: 'rf_1' },
        { code: 'SO', sideBarLinks: sodSideBarLinks, reportsNodeId: '2_4', reportPermKeys: ['SODReports', 'SODMenu'], treeId: 'sod_2' },
        { code: 'TA', sideBarLinks: TaskAgentSideBarLinks, treeId: 'task_99' },
        { code: 'TM', sideBarLinks: tmSideBarLinks, reportsNodeId: '7_3', treeId: 'tm_7' },
        { code: 'WM', sideBarLinks: wmSideBarLinks, reportsNodeId: 'wmSideBarLinks_0_8', reportPermKeys: ['Reports', 'WMMenu'], treeId: 'wm_1' },
        { code: 'XM', sideBarLinks: xmSideBarLinks, treeId: 'xm_99' },
        ...simpleModuleDefinitions.map((m) => ({ code: m.code, sideBarLinks: m.sideBarLinks, treeId: `${m.code.toLowerCase()}_1`, reportPermKeys: m.reportPermKeys })),
    ];

    moduleMenuConfigs.forEach((m) => {
        const lower = m.code.toLowerCase();
        if (!m.reportPermKeys) m.reportPermKeys = [`${m.code}Reports`, `${m.code}Menu`];
        // Modules without a code-defined Reports node get an empty one so the
        // DB-driven report groups have a place to overlay onto.
        if (!m.reportsNodeId) {
            m.reportsNodeId = `${lower}_reports`;
            m.sideBarLinks.push({
                id: m.reportsNodeId,
                text: 'Reports',
                icon: 'fa fa-folder',
                expanded: false,
                items: []
            });
        }

        m.dashboardLiteIndex = m.sideBarLinks.push({
            id: `Dashboard_${lower}_lite`,
            text: dashBoardMenuText,
            icon: 'fa fa-folder',
            expanded: false,
            path: "/dbl/management/viewdashboard",
            items: []
        });
        m.dashboardIndex = m.sideBarLinks.push({
            id: `Dashboard_${lower}_dx`,
            text: dxDashBoardMenuText,
            icon: 'fa fa-folder',
            expanded: false,
            path: "/db/ManageDashboard",
            items: []
        });
        m.artIndex = m.sideBarLinks.push({
            id: `ArtReports_${lower}`,
            text: artReportsMenuText,
            icon: 'fa fa-folder',
            expanded: false,
            path: "/at/artreport",
            items: []
        });
    });
    var OMSetup = OMSideBarLinks.push({
        id: 'Setup_1_1',
        text: "Setup",
        icon: 'fa fa-folder',
        expanded: false,
        path: "/om/setup",
        items: [
            {
                text: 'Global Setup',
                icon: window._env_.REACT_APP_MENU_USE_PNG ? ScreenIcon : 'icon icon-ag-seed-inventory',
                path: "/om/setup",
                permission: PermissionsConstants.OMSetup
            }
        ]
    }
    );
    OMSideBarLinks.push({
        id: 'OMProfile_1_1',
        text: "Data Profiles",
        icon: 'fa fa-folder',
        expanded: false,
        path: "/om/data-profiles/salesorder-profile-data-entry",
        items: [
            {
                text: 'Transaction Profile Data Entry',
                icon: window._env_.REACT_APP_MENU_USE_PNG ? ScreenIcon : 'icon icon-ag-seed-inventory',
                path: "/om/data-profiles/salesorder-profile-data-entry",
                permission: PermissionsConstants.OMSalesOrderProfile
            }
        ]
    }
    );
        OMSideBarLinks.push({
        id: 'OMCodes_1_1',
        text: "Codes",
        icon: 'fa fa-folder',
        expanded: false,
        path: "/om/codes/item-data-entry-list",
        items: [
            {
                text: 'Item Data Entry',
                icon: window._env_.REACT_APP_MENU_USE_PNG ? ScreenIcon : 'icon icon-ag-seed-inventory',
                path: "/om/codes/item-data-entry-list",
                permission: PermissionsConstants.OMItemDataEntry
            },
                        {
                text: 'Lot Data Entry',
                icon: window._env_.REACT_APP_MENU_USE_PNG ? ScreenIcon : 'icon icon-ag-seed-inventory',
                path: "/om/codes/lot-data-entry-list",
                permission: PermissionsConstants.OMLotDataEntry
            },
            {
                text: 'Descriptive Codes Data Entry',
                icon: window._env_.REACT_APP_MENU_USE_PNG ? ScreenIcon : 'icon icon-ag-seed-inventory',
                path: "/om/codes/descriptive-codes-data-entry-list",
                permission: PermissionsConstants.OMDescriptiveCodes
            },
            {
                text: 'Sales Tax Code Data Entry',
                icon: window._env_.REACT_APP_MENU_USE_PNG ? ScreenIcon : 'icon icon-ag-seed-inventory',
                path: "/om/codes/sales-tax-code-data-entry-list",
                permission: PermissionsConstants.OMSalesTaxCodes
            }
        ]
    }
    );
    if (props.sidebarMinimized) {
        if(treeViewRef.current) {  
            treeViewRef.current.instance().collapseAll();
        }
    }


    // Pull the DB-driven report menus (OM, WM, ...) before the role-permission
    // build so each module's Reports node can be rendered from the report groups.
    const fetchReportMenusData = async () => {
        try {
            // One API call returns the report menus for every module; group the
            // payload by its Module here. Adding more modules needs no extra calls.
            const allMenus = await getReportMenuAll(accessToken);
            const grouped = {};
            (allMenus || []).forEach((menu) => {
                const mod = menu && menu.Module;
                if (!mod) return;
                (grouped[mod] = grouped[mod] || []).push(menu);
            });
            reportMenusRef.current = grouped;
            // Share the raw menu so AppContainer derives its report routes + permission map
            // from this single fetch (no duplicate API call there).
            dispatch(SET_REPORT_MENU(allMenus));
        } catch (e) {
            console.error('Error fetching report menus', e);
        }
    };

    // Collect every leaf (node without an items[] array) under a tree node.
    const collectReportLeaves = (node, acc) => {
        (node.items || []).forEach(child => {
            if (Array.isArray(child.items)) collectReportLeaves(child, acc);
            else acc.push(child);
        });
    };

    // Remove matched leaves from the default tree and drop folders left empty.
    const pruneReportTree = (node, matched) => {
        if (!Array.isArray(node.items)) return;
        node.items = node.items.filter(child => {
            if (Array.isArray(child.items)) {
                pruneReportTree(child, matched);
                return child.items.length > 0;
            }
            return !matched.has(child);
        });
    };

    // OVERLAY the DB report groups onto a module's (code-defined) Reports node.
    // Defaults stay in code; reports that appear in the DB overlay are moved under
    // their group (with optional label override). Unmatched defaults stay as-is.
    // Permissions are applied at group AND item level: a group/report with a
    // PERMISSION the role doesn't have is hidden (null permission = always shown).
    const applyReportOverlay = (reportsNode, overlayGroups, idPrefix, allowedPerms) => {
        if (!reportsNode || !Array.isArray(overlayGroups) || overlayGroups.length === 0) return;
        const usePng = window._env_.REACT_APP_MENU_USE_PNG;
        const permOk = (p) => !p || !(allowedPerms instanceof Set) || allowedPerms.has(p);

        const leaves = [];
        collectReportLeaves(reportsNode, leaves);
        const byKey = {};
        leaves.forEach(l => {
            const k = leafKeyFromPath(l.path);
            if (k && !(k in byKey)) byKey[k] = l;
        });

        const matched = new Set();
        const built = [];
        overlayGroups.forEach((grp, gi) => {
            const groupItems = [];
            (grp.ReportGroupItems || []).forEach((it, ri) => {
                const key = overlayItemKey(it);
                const existing = key ? byKey[key] : null;
                // A report referenced by the DB is removed from the default tree whether
                // it ends up shown or gated out (so it never leaks into the old folders).
                if (existing) matched.add(existing);
                // Permission gating is per report item only (groups carry no permission). The DB
                // value is authoritative - it is maintained on the Report Groups screen, and a
                // blank one deliberately means "visible to every role".
                if (!permOk(it.Permission)) return; // gated out -> not rendered
                if (existing) {
                    const leaf = { ...existing, id: `${idPrefix}_${gi}_${ri}`, permission: it.Permission || null };
                    if (it.Description) leaf.text = it.Description;
                    groupItems.push(leaf);
                } else {
                    const synth = synthLeafFromOverlay(it, `${idPrefix}_${gi}_${ri}`);
                    synth.icon = usePng ? ReportTemplateIcon : 'icon icon-ag-report';
                    groupItems.push(synth);
                }
            });
            if (groupItems.length === 0) return;
            if (!grp.GroupName) {
                built.push(...groupItems);
            } else {
                built.push({
                    id: `${idPrefix}_grp_${gi}`,
                    text: grp.GroupName,
                    icon:'fa fa-folder',
                    expanded: false,
                    items: groupItems,
                });
            }
        });

        pruneReportTree(reportsNode, matched);
        reportsNode.items = [...built, ...(reportsNode.items || [])];
    };

    //////////////////////
    useEffect(() => {
        setLoadingSidebar(true)
        fetchDashboardMenuData()
            .then(() => fetchReportMenusData())
            .then(() => {
                fetchRolePermissions().then(() => getShortcuts());
            }).catch(error => {
                console.error('Error during data fetch:', error);
            }).finally(() => setLoadingSidebar(false));

    }, []);
    useEffect(() => {
        addItemsToShortcuts(shortcuts);
    }, [shortcuts]);
    const getShortcuts = () => {
        axios.get(
            `${window._env_.REACT_APP_APIS}/${data.Shortcuts.GetShortcuts}`,
            {
                params: { includeGlobal: false },
                headers: {
                    "Content-Type": "application/json",
                    access_token: accessToken,
                    Authorization: `Bearer ${accessToken}`,
                },
            }
        ).then((res) => {
            if (res.data == null) return;
            const { personal } = parseShortcutsApiResponse(res.data);
            setShortcuts(personal);
        }).catch(() => setShortcuts([]));

    }
    const fetchRolePermissions = () => {
        return new Promise((resolve, reject) => {
            axios
                .get(
                    `${window._env_.REACT_APP_AUTH_URL}/${data.idp.GetPermissionsByRole}?roleName=${props.oidc.user.profile.role}`
                )
                .then((res) => {
                    dispatch(Fetch_Roles_Permissions(res.data));
                    axios.get
                        (
                            `${window._env_.REACT_APP_APIS}/${data.reports.GetArtReports}`,
                            {
                                headers: {
                                    "Content-Type": "application/json",
                                    access_token: accessToken,
                                    Authorization: `Bearer ${accessToken}`,
                                },
                            }
                        )
                        .then((artReportRes) => {

                            const appSettings = getAppSettings();
                            
                            if (res.data.hasOwnProperty("AIMenu")) // || (appSettings && res.data.hasOwnProperty("RoleId") && appSettings.AIAssitantLimitedAccessRole === res.data.RoleId[0]))
                            {
                                var aiSidebar = [];

                                if (res.data.AIMenu.includes(PermissionsConstants.AIMenuViewChat)) {
                                    aiSidebar.push({
                                        id: "ai_1_1",
                                        text: "Chat",
                                        icon: window._env_.REACT_APP_MENU_USE_PNG ? ScreenIcon : 'fa fa-weixin',  
                                        path: "/ai/chat"
                                    });
                                    props.setChatMenuRight(true);
                                }
                                else
                                {
                                    props.setChatMenuRight(false);
                                }

                                if (res.data.AIMenu.includes(PermissionsConstants.AIMenuViewVectorStoreDataEntry)) {
                                    aiSidebar.push({
                                        id: "ai_1_2",
                                        text: "Vector Store Data Entry",
                                        icon: window._env_.REACT_APP_MENU_USE_PNG ? ScreenIcon : 'fa fa-weixin',  
                                        path: "/ai/vectorstore-data-entry"
                                    });
                                }
                                
                                if (res.data.AIMenu.includes(PermissionsConstants.AIMenuViewFileDataEntry)) {
                                    aiSidebar.push({
                                        id: "ai_1_3",
                                        text: "File Data Entry",
                                        icon: window._env_.REACT_APP_MENU_USE_PNG ? ScreenIcon : 'fa fa-file',  
                                        path: "/ai/file-data-entry"
                                    });
                                }

                                if (res.data.AIMenu.includes(PermissionsConstants.AIMenuViewUsageMetrics)) {
                                    aiSidebar.push({
                                        id: "ai_1_4",
                                        text: "Usage Metrics",
                                        icon: window._env_.REACT_APP_MENU_USE_PNG ? ScreenIcon : 'fa fa-bar-chart',
                                        path: "/ai/usage-metrics"
                                    });
                                }
                                
                                setTreeviewData(treeviewData.splice(2, 0, 
                                    {
                                        id: "ai_1",
                                        text: "AI Assistant",
                                        icon: window._env_.REACT_APP_MENU_USE_PNG ? WmIcon : 'fa fa-folder',
                                        orderNumber: 3,
                                        expanded: false,
                                        items: aiSidebar
                                    }
                                ));
                            }
                            else
                            {
                                props.setChatMenuRight(false);
                            }

                            for (var i = 0; i < artReportRes.data.length; i++) {
                                const artItem = artReportRes.data[i];
                                if (artItem.moduleslist != null && artItem.webrole != null
                                    && props.oidc.user.profile.role != null && artItem.webrole.includes(props.oidc.user.profile.role)) {
                                    moduleMenuConfigs.forEach((m) => {
                                        if (artItem.moduleslist.includes(m.code)) {
                                            m.sideBarLinks[m.artIndex - 1].items.push({
                                                text: artItem.layoutname,
                                                icon: window._env_.REACT_APP_MENU_USE_PNG ? ReportTemplateIcon : 'icon icon-ag-report',
                                                path: "/at/artreport/" + artItem.layoutname,
                                                permission: null
                                            });
                                        }
                                    });
                                }
                            }

                            // Report groups come from the DB; overlay them onto every module's
                            // Reports node before the permission-filtered sidebars are built below.
                            moduleMenuConfigs.forEach((m) => {
                                const reportsNode = m.sideBarLinks.find(n => n.id === m.reportsNodeId);
                                applyReportOverlay(reportsNode, reportMenusRef.current[m.code], `${m.code.toLowerCase()}_dyn`, buildPermSet(res?.data, m.reportPermKeys));
                            });
                            let sodSidebarMain = [];
                            sodSideBarLinks.map((link, i) => {
                                let lnks = link.items.filter(el => el.permission == null || res?.data?.SODMenu?.includes(el.permission) || res?.data?.SODReports?.includes(el.permission) );
                                if (lnks.length) {
                                    let sidebar = {};
                                    sidebar.id = link.id;
                                    sidebar.text = link.text;
                                    sidebar.icon = 'fa fa-folder';
                                    sidebar.items = lnks;
                                    sodSidebarMain.push(sidebar);
                                }
                            });

                            let tmSidebarMain = [];
                            tmSideBarLinks.map((link, i) => {
                                let lnks = link.items.filter(el => el.permission == null || res?.data?.TMMenu?.includes(el.permission));
                                if (lnks.length) {
                                    let sidebar = {};
                                    sidebar.id = link.id;
                                    sidebar.text = link.text;
                                    sidebar.icon = "fa fa-folder";
                                    sidebar.items = lnks;
                                    tmSidebarMain.push(sidebar);
                                }
                            });

                            //setTMMainMenu(tmSidebarMain);

                            let wmSidebar = [];
                            let rfSidebar = [];
                            var transactionFlag = false;
                            if (res.data.hasOwnProperty("TransactionReceipt")) {
                                for (var i = 0; i < res.data.TransactionReceipt.length; i++) {
                                    if (res.data.TransactionReceipt[i] == 'Read') {
                                        transactionFlag = true;
                                        break;
                                    }
                                }
                            }

                            if (transactionFlag == false && res.data.hasOwnProperty("TransactionShipment")) {
                                for (var i = 0; i < res.data.TransactionShipment.length; i++) {
                                    if (res.data.TransactionShipment[i] == 'Read') {
                                        transactionFlag = true;
                                        break;
                                    }
                                }
                            }

                            if (transactionFlag == false && res.data.hasOwnProperty("TransactionAdjustment")) {
                                for (var i = 0; i < res.data.TransactionAdjustment.length; i++) {
                                    if (res.data.TransactionAdjustment[i] == 'Read') {
                                        transactionFlag = true;
                                        break;
                                    }
                                }
                            }

                            let securitySidebar = [];
                            if (res.data.hasOwnProperty("Security") && res.data.Security.includes(PermissionsConstants.SecurityRead)) {
                                securitySideBarLinks.push(
                            {
                                id: "security_7_2",
                                text: "User Security",
                                icon: window._env_.REACT_APP_MENU_USE_PNG ? ScreenIcon : 'fa fa-user',
                                path: "/security/user-security",
                                permission: null,
                            }
                        )}
                            if (res.data.hasOwnProperty("Security") && res.data.Security.includes(PermissionsConstants.CustomerAccountAdministration)) {
                                securitySideBarLinks.push({
                                    id: "security_7_8",
                                    text: "Customer Account Administration",
                                    icon: window._env_.REACT_APP_MENU_USE_PNG ? ScreenIcon : 'fa fa-user',
                                    path: "/security/customer-account-administration",
                                    permission: null,
                                });
                            }
                            if (res.data.hasOwnProperty("Security") && res.data.Security.includes(PermissionsConstants.SecurityFacilities)) {
                                securitySideBarLinks.push({
                                    id: "security_7_3",
                                    text: "Facilities",
                                    icon: window._env_.REACT_APP_MENU_USE_PNG ? ScreenIcon : 'icon fa fa-user',
                                    path: "/security/facilities",
                                    permission: null,
                                });
                            }
                            if (res.data.hasOwnProperty("Security") && res.data.Security.includes(PermissionsConstants.ApplicationSettings)) {
                                securitySideBarLinks.push({
                                    id: "security_7_5",
                                    text: "Application Settings",
                                    icon: window._env_.REACT_APP_MENU_USE_PNG ? ScreenIcon : 'fa fa-user',
                                    path: "/security/app-settings",
                                    permission: null,
                                });
                            }
                            if (res.data.hasOwnProperty("Security") && res.data.Security.includes(PermissionsConstants.ApiAuditLogs)) {
                                securitySideBarLinks.push({
                                    id: "security_7_6",
                                    text: "API Audit Logs",
                                    icon: window._env_.REACT_APP_MENU_USE_PNG ? ScreenIcon : 'fa fa-user',
                                    path: "/security/api-audit-logs",
                                    permission: null,
                                });
                            }
                            // A link with a permission is shown only when the role actually holds it.
                            // The permission has to be looked for INSIDE the category arrays -
                            // testing the category name (`key.includes(...)`) never matches a real
                            // permission value, which let gated screens through.
                            securitySideBarLinks.forEach((link) => {
                                if (securitySidebar.indexOf(link) >= 0) return;
                                if (link.permission == null) {
                                    securitySidebar.push(link);
                                    return;
                                }
                                for (let key in res.data) {
                                    if (Array.isArray(res.data[key]) && res.data[key].includes(link.permission)) {
                                        securitySidebar.push(link);
                                        break;
                                    }
                                }
                            });

                            let xmSidebar = [];
                            let taskAgentSidebar = [];

                            xmSideBarLinks.forEach((link) => {
                                if (link.permission == null) {
                                    // Parents without their own permission (e.g. Dashboard / Art Reports)
                                    // only show if they have at least one child populated by the API.
                                    if (link.items && link.items.length > 0) {
                                        xmSidebar.push(link);
                                    }
                                } else {
                                    for (let key in res.data) {
                                        if (Array.isArray(res.data[key]) && res.data[key].includes(link.permission)) {
                                            xmSidebar.push(link);
                                            break;
                                        }
                                    }
                                }
                            });
                            let poSidebar = [];
                            poSideBarLinks.map((link) => {
                                let lnks = link.items.filter(el => el.permission == null || (res?.data?.POMenu?.includes(el.permission)));
                                if (lnks.length) {
                                    let sidebar = {};
                                    sidebar.id = link.id;
                                    sidebar.text = link.text;
                                    sidebar.icon = "fa fa-folder";
                                    sidebar.items = lnks;
                                    poSidebar.push(sidebar);
                                }
                            });
                            TaskAgentSideBarLinks.forEach((link) => {
                                if (link.permission == null) {
                                    if (link.items && link.items.length > 0) {
                                        taskAgentSidebar.push(link);
                                    }
                                } else {
                                    for (let key in res.data) {
                                        if (Array.isArray(res.data[key]) && res.data[key].includes(link.permission)) {
                                            taskAgentSidebar.push(link);
                                            break;
                                        }
                                    }
                                }
                            });
                            if (transactionFlag == true) {
                                wmSideBarLinks[wmCustomerTrackingIndex - 1].items.push({
                                    text: "Transactions",
                                    icon: window._env_.REACT_APP_MENU_USE_PNG ? ScreenIcon : 'icon icon-ag-transaction',
                                    path: "/wm/transaction",
                                    permission: PermissionsConstants.Transaction
                                });
                               
                            }
                            if (res.data.hasOwnProperty("WMMenu") && res.data.WMMenu.includes(PermissionsConstants.WMMenuViewMockupV1)) {
                                wmSideBarLinks[wmCustomerTrackingIndex - 1].items.push({
                                    text: "mockupv1",
                                    icon: window._env_.REACT_APP_MENU_USE_PNG ? ScreenIcon : 'icon icon-ag-transaction',
                                    path: "/wm/mockupv1",
                                    permission: null
                                });
                            }
                            if (res.data.hasOwnProperty("WMMenu") && res.data.WMMenu.includes(PermissionsConstants.WMMenuViewMockupV2)) {
                                wmSideBarLinks[wmCustomerTrackingIndex - 1].items.push({
                                    text: "mockupv2",
                                    icon: window._env_.REACT_APP_MENU_USE_PNG ? ScreenIcon : 'icon icon-ag-transaction',
                                    path: "/wm/mockupv2",
                                    permission: null
                                });
                            }
                            if (res.data.hasOwnProperty("WMMenu") && res.data.WMMenu.includes(PermissionsConstants.WMMenuViewMockupV3)) {
                                wmSideBarLinks[wmCustomerTrackingIndex - 1].items.push({
                                    text: "mockupv3",
                                    icon: window._env_.REACT_APP_MENU_USE_PNG ? ScreenIcon : 'icon icon-ag-transaction',
                                    path: "/wm/mockupv3",
                                    permission: null
                                });
                            }
                            wmSideBarLinks[wmCustomerTrackingIndex - 1].items.push({
                                text: "History",
                                icon: window._env_.REACT_APP_MENU_USE_PNG ? ScreenIcon : 'icon icon-ag-history',
                                path: "/wm/history",
                                permission: PermissionsConstants.History,
                            });
                            
                            
                            wmSideBarLinks[wmCustomerTrackingIndex - 1].items.push({
                                text: "Inventory Items",
                                icon: window._env_.REACT_APP_MENU_USE_PNG ? ScreenIcon : 'icon icon-ag-seed-inventory',
                                path: "/wm/inventory-items",
                                permission: PermissionsConstants.InventoryItems,
                            });

                            if (res.data.hasOwnProperty("WMMenu") && res.data.WMMenu.includes(PermissionsConstants.GeneratePhysicalInventoryCount)) {
                                wmSideBarLinks[wmPhysicalCountTrackingIndex - 1].items.push({
                                    text: 'Generate Count Records',
                                    icon: window._env_.REACT_APP_MENU_USE_PNG ? ScreenIcon : 'icon icon-ag-seed-inventory',
                                    path: "/wm/genneratecountrecords",
                                    permission: null
                                });
                            }
                            if (res.data.hasOwnProperty("WMMenu") && res.data.WMMenu.includes(PermissionsConstants.CountResults)) {
                                wmSideBarLinks[wmPhysicalCountTrackingIndex - 1].items.push({
                                    text: "Enter Count Results",
                                    icon: window._env_.REACT_APP_MENU_USE_PNG ? ScreenIcon : 'icon icon-ag-seed-inventory',
                                    path: "/wm/enter-count-results",
                                    permission: null,
                                });
                                
                            }
                            if (res.data.hasOwnProperty("WMMenu") && res.data.WMMenu.includes(PermissionsConstants.ViewCountAdjustments)) {
                                wmSideBarLinks[wmPhysicalCountTrackingIndex - 1].items.push({
                                    text: "Generate Count Adjustments",
                                    icon: window._env_.REACT_APP_MENU_USE_PNG ? ScreenIcon : 'icon icon-ag-seed-inventory',
                                    path: "/wm/generate-count-adjustments",
                                    permission: null,
                                });
                                 
                            }

                            if (res.data.hasOwnProperty("WMMenu") && res.data.WMMenu.includes(PermissionsConstants.OwnerShipTransferView)) {
                                wmSideBarLinks[wmCustomerTrackingIndex - 1].items.push({
                                    text: 'Ownership Transfer',
                                    icon: window._env_.REACT_APP_MENU_USE_PNG ? ScreenIcon : 'icon icon-ag-seed-inventory',
                                    path: "/wm/ownershiptransfer",
                                    permission: null
                                });
                               
                            }

                            if (res.data.hasOwnProperty("WMMenu") && res.data.WMMenu.includes(PermissionsConstants.WMTransactionManagement)) {
                                wmSideBarLinks[0].items.push({
                                    text: "Transactions Management",
                                    icon: window._env_.REACT_APP_MENU_USE_PNG ? ScreenIcon : 'icon icon-ag-seed-inventory',
                                    path: "/wm/transactionmanagement",
                                    permission: null
                                });
                            }

                            if (res.data.hasOwnProperty("WMMenu") && res.data.WMMenu.includes(PermissionsConstants.WMTransactionDataEntry)) {
                                wmSideBarLinks[0].items.push({
                                    text: 'Transaction Data Entry',
                                    icon: window._env_.REACT_APP_MENU_USE_PNG ? ScreenIcon : 'icon icon-ag-seed-inventory',
                                    path: "/wm/transactiondataentry",
                                    permission: null
                                });
                            }

                            if (res.data.hasOwnProperty("WMMenu") && res.data.WMMenu.includes(PermissionsConstants.WMSchedulesManagement)) {
                                wmSideBarLinks[0].items.push({
                                    text: 'Schedules Management',
                                    icon: window._env_.REACT_APP_MENU_USE_PNG ? ScreenIcon : 'icon icon-ag-seed-inventory',
                                    path: "/wm/schedulesmanagement",
                                    permission: null
                                });
                            }

                            if (res.data.hasOwnProperty("Codes") && res.data.Codes.includes(PermissionsConstants.WMCustomer)) {
                                wmSideBarLinks[2].items.push({
                                    text: 'Customer Data Entry',
                                    icon: window._env_.REACT_APP_MENU_USE_PNG ? ScreenIcon : 'icon icon-ag-seed-inventory',
                                    path: "/wm/codes/customer-data-entry",
                                    permission: null
                                });
                            }

                            if (res.data.hasOwnProperty("Codes") && res.data.Codes.includes(PermissionsConstants.WMCarrier)) {
                                wmSideBarLinks[2].items.push({
                                    text: 'Carrier/Ship Via Data Entry',
                                    icon: window._env_.REACT_APP_MENU_USE_PNG ? ScreenIcon : 'icon icon-ag-seed-inventory',
                                    path: "/wm/codes/carrier-data-entry",
                                    permission: null
                                });
                            }

                            if (res.data.hasOwnProperty("Codes") && res.data.Codes.includes(PermissionsConstants.WMConsignee)) {
                                wmSideBarLinks[2].items.push({
                                    text: 'Consignee Data Entry',
                                    icon: window._env_.REACT_APP_MENU_USE_PNG ? ScreenIcon : 'icon icon-ag-seed-inventory',
                                    path: "/wm/codes/consignee-data-entry",
                                    permission: null
                                });
                            }

                            if (res.data.hasOwnProperty("Codes") && res.data.Codes.includes(PermissionsConstants.WarehouseDataEntry)) {
                                wmSideBarLinks[2].items.push({
                                    text: 'Warehouse Data Entry',
                                    icon: window._env_.REACT_APP_MENU_USE_PNG ? ScreenIcon : 'icon icon-ag-seed-inventory',
                                    path: "/wm/codes/warehouse-data-entry",
                                    permission: null
                                });
                             }

                            if (res.data.hasOwnProperty("Codes") && res.data.Codes.includes(PermissionsConstants.WMWeekSettings)) {
                                wmSideBarLinks[2].items.push({
                                    text: 'Warehouse Weekly Settings',
                                    icon: window._env_.REACT_APP_MENU_USE_PNG ? ScreenIcon : 'icon icon-ag-seed-inventory',
                                    path: "/wm/codes/week-settings",
                                    permission: null
                                });
                             }

                            if (res.data.hasOwnProperty("Codes") && res.data.Codes.includes(PermissionsConstants.WMExceptions)) {
                                wmSideBarLinks[2].items.push({
                                    text: 'Warehouse Exceptions',
                                    icon: window._env_.REACT_APP_MENU_USE_PNG ? ScreenIcon : 'icon icon-ag-seed-inventory',
                                    path: "/wm/codes/exceptions",
                                    permission: null
                                });
                             }

                            if (res.data.hasOwnProperty("Codes") && res.data.Codes.includes(PermissionsConstants.WMMenuLocationDataEntry)) {
                                wmSideBarLinks[2].items.push({
                                    text: "Location Data Entry",
                                    icon: window._env_.REACT_APP_MENU_USE_PNG ? ScreenIcon : 'icon icon-ag-report',
                                    path: "/wm/codes/location-data-entry",
                                    permission: null,
                                });
                            }
                            if (res.data.hasOwnProperty("Codes") && res.data.Codes.includes(PermissionsConstants.WMCrateDataEntry)) {
                                wmSideBarLinks[2].items.push({
                                    text: "Crates Data Entry",
                                    icon: window._env_.REACT_APP_MENU_USE_PNG ? ScreenIcon : 'icon icon-ag-report',
                                    path: "/wm/codes/crate-data-entry",
                                    permission: null,
                                });
                            }
                             if (res.data.hasOwnProperty("DataProfiles") && res.data.DataProfiles.includes(PermissionsConstants.WMSearchTransactionPrf)) {
                                wmSideBarLinks[3].items.push({
                                    text: 'Transaction Profile Data Entry',
                                    icon: window._env_.REACT_APP_MENU_USE_PNG ? ScreenIcon : 'icon icon-ag-seed-inventory',
                                    path: "/wm/DataProfiles/SearchTransactionProfiles",
                                    permission: null
                                });
                            }
                            if (res.data.hasOwnProperty("DataProfiles") && res.data.DataProfiles.includes(PermissionsConstants.WMItemKitProfile)) {
                                wmSideBarLinks[3].items.push({
                                    text: 'Enter Item Kit Profiles',
                                    icon: window._env_.REACT_APP_MENU_USE_PNG ? ScreenIcon : 'icon icon-ag-seed-inventory',
                                    path: "/wm/data-profiles/item-kit-profiles",
                                    permission: null
                                });
                            }
                            if (res.data.hasOwnProperty("DataProfiles") && res.data.DataProfiles.includes(PermissionsConstants.WMItemDataProfile)) {
                                wmSideBarLinks[3].items.push({
                                    text: 'Item Data Profile Data Entry',
                                    icon: window._env_.REACT_APP_MENU_USE_PNG ? ScreenIcon : 'icon icon-ag-seed-inventory',
                                    path: PermissionsConstants.ItemDataProfileRoutes.List,
                                    permission: null
                                });
                            }
                            if (res.data.hasOwnProperty("DataProfiles") && res.data.DataProfiles.includes(PermissionsConstants.WMChargeProfile)) {
                                wmSideBarLinks[3].items.push({
                                    text: 'Enter Charge Profiles',
                                    icon: window._env_.REACT_APP_MENU_USE_PNG ? ScreenIcon : 'icon icon-ag-seed-inventory',
                                    path: PermissionsConstants.ChargeProfileRoutes.List,
                                    permission: null
                                });
                            }
                            if (res.data.hasOwnProperty("DataProfiles") && res.data.DataProfiles.includes(PermissionsConstants.WMRateScheduleProfile)) {
                                wmSideBarLinks[3].items.push({
                                    text: 'Enter Rate Schedule Profiles',
                                    icon: window._env_.REACT_APP_MENU_USE_PNG ? ScreenIcon : 'icon icon-ag-seed-inventory',
                                    path: PermissionsConstants.RateScheduleProfileRoutes.List,
                                    permission: null
                                });
                            }
                            if (res.data.hasOwnProperty("DataProfiles") && res.data.DataProfiles.includes(PermissionsConstants.WMCrateProfile)) {
                                wmSideBarLinks[3].items.push({
                                    text: 'Enter Crate Profiles',
                                    icon: window._env_.REACT_APP_MENU_USE_PNG ? ScreenIcon : 'icon icon-ag-seed-inventory',
                                    path: PermissionsConstants.CrateProfileRoutes.List,
                                    permission: null
                                });
                            }
                            if (res.data.hasOwnProperty("DataProfiles") && res.data.DataProfiles.includes(PermissionsConstants.WMTransManagementProfile)) {
                                wmSideBarLinks[3].items.push({
                                    text: 'Transaction Management Data Profile',
                                    icon: window._env_.REACT_APP_MENU_USE_PNG ? ScreenIcon : 'icon icon-ag-seed-inventory',
                                    path: PermissionsConstants.TransManagementProfileRoutes.List,
                                    permission: null
                                });
                            }
                            if (res.data.hasOwnProperty("Codes") && res.data.Codes.includes(PermissionsConstants.WMItemDataEntry)) {
                                wmSideBarLinks[2].items.push({
                                    text: 'Item Data Entry',
                                    icon: window._env_.REACT_APP_MENU_USE_PNG ? ScreenIcon : 'icon icon-ag-seed-inventory',
                                    path: "/wm/codes/item-data-entry",
                                    permission: null
                                });
                             }
                             
                            if (res.data.hasOwnProperty("Codes") && res.data.Codes.includes(PermissionsConstants.WMDescriptiveCode)) {
                                wmSideBarLinks[2].items.push({
                                    text: 'Descriptive Codes',
                                    icon: window._env_.REACT_APP_MENU_USE_PNG ? ScreenIcon : 'icon icon-ag-seed-inventory',
                                    path: "/wm/codes/descriptive-codes-data-entry-list",
                                    permission: null
                                });
                             }
                             if (res.data.hasOwnProperty("Codes") && res.data.Codes.includes(PermissionsConstants.WMChargeCode)) {
                                wmSideBarLinks[2].items.push({
                                    text: 'Enter Charge Codes',
                                    icon: window._env_.REACT_APP_MENU_USE_PNG ? ScreenIcon : 'icon icon-ag-seed-inventory',
                                    path: "/wm/codes/charge-code",
                                    permission: null
                                });
                             }
                             if (res.data.hasOwnProperty("Codes") && res.data.Codes.includes(PermissionsConstants.WMEditSerialNumberRecords)) {
                                wmSideBarLinks[2].items.push({
                                    text: 'Serial Number Codes',
                                    icon: 'fa fa-folder',
                                    expanded: false,
                                    items: [
                                        {
                                            text: 'Edit Serial Number Records',
                                            icon: window._env_.REACT_APP_MENU_USE_PNG ? ScreenIcon : 'icon icon-ag-seed-inventory',
                                            path: "/wm/codes/serial-number/edit",
                                            permission: null
                                        }
                                    ]
                                });
                             }
                             if (res.data.hasOwnProperty("Codes") && res.data.Codes.includes(PermissionsConstants.WMRateCode)) {
                                wmSideBarLinks[2].items.push({
                                    text: 'Enter Rate Codes',
                                    icon: window._env_.REACT_APP_MENU_USE_PNG ? ScreenIcon : 'icon icon-ag-seed-inventory',
                                    path: "/wm/codes/rate-codes",
                                    permission: null
                                });
                             }
                             if (res.data.hasOwnProperty("Codes") && res.data.Codes.includes(PermissionsConstants.WMRateScheduleCode)) {
                                wmSideBarLinks[2].items.push({
                                    text: 'Enter Rate Schedule Codes',
                                    icon: window._env_.REACT_APP_MENU_USE_PNG ? ScreenIcon : 'icon icon-ag-seed-inventory',
                                    path: "/wm/codes/rate-schedule-codes",
                                    permission: null
                                });
                             }
                             if (res.data.hasOwnProperty("Codes") && res.data.Codes.includes(PermissionsConstants.WMItemKitCode)) {
                                wmSideBarLinks[2].items.push({
                                    text: 'Enter Item Kit Codes',
                                    icon: window._env_.REACT_APP_MENU_USE_PNG ? ScreenIcon : 'icon icon-ag-seed-inventory',
                                    path: "/wm/codes/item-kit-codes",
                                    permission: null
                                });
                             }
                             if (res.data.hasOwnProperty("Codes") && res.data.Codes.includes(PermissionsConstants.WMLotDataEntry)) {

                                wmSideBarLinks[2].items.push({
                                    text: 'Lot Data Entry',
                                    icon: window._env_.REACT_APP_MENU_USE_PNG ? ScreenIcon : 'icon icon-ag-seed-inventory',
                                    path: "/wm/codes/lot-data-entry",
                                    permission: null
                                });
                             }
                             if (res.data.hasOwnProperty("PeriodicTasks") && res.data.PeriodicTasks.includes(PermissionsConstants.RFMessages)) {
                                rfSideBarLinks[0].items.push({
                                    text: 'RF Messages',
                                    icon: window._env_.REACT_APP_MENU_USE_PNG ? ScreenIcon : 'icon icon-ag-seed-inventory',
                                    path: "/rf/periodictasks/rfmessages",
                                    permission: null
                                });
                             }
                             if (res.data.hasOwnProperty("Codes") && res.data.Codes.includes(PermissionsConstants.WMSublotDataEntry)) {
                                wmSideBarLinks[2].items.push({
                                    text: 'Sublot Data Entry',
                                    icon: window._env_.REACT_APP_MENU_USE_PNG ? ScreenIcon : 'icon icon-ag-seed-inventory',
                                    path: "/wm/codes/sublot-data-entry",
                                    permission: null
                                });
                             }
                             if (res.data.hasOwnProperty("Codes") && res.data.Codes.includes(PermissionsConstants.WMEvaluationExpression)) {
                                wmSideBarLinks[2].items.push({
                                    text: 'Manage Evaluation Expression',
                                    icon: window._env_.REACT_APP_MENU_USE_PNG ? ScreenIcon : 'icon icon-ag-seed-inventory',
                                    path: "/wm/codes/manage-evaluation-expression",
                                    permission: null
                                });
                             }
                             if (res.data.hasOwnProperty("Codes") && res.data.Codes.includes(PermissionsConstants.WMDynValChargeConfig)) {
                                wmSideBarLinks[2].items.push({
                                    text: 'Manage Dynamically Evaluated Charges Configurations',
                                    icon: window._env_.REACT_APP_MENU_USE_PNG ? ScreenIcon : 'icon icon-ag-seed-inventory',
                                    path: "/wm/codes/dyn-eval-charge-config",
                                    permission: null
                                });
                             }
                            if (res.data.hasOwnProperty("Setup") && res.data.Setup.includes(PermissionsConstants.WMTransNumSetup)) {
                                wmSideBarLinks[4].items.push({
                                    text: 'Global Setup',
                                    icon: window._env_.REACT_APP_MENU_USE_PNG ? ScreenIcon : 'icon icon-ag-seed-inventory',
                                    path: "/wm/setup/trans-num",
                                    permission: null
                                });
                            }
                            if (res.data.hasOwnProperty("WMMenu") && res.data.WMMenu.includes(PermissionsConstants.WMMenuGenerateInvoices)) {
                                wmSideBarLinks[wmInvoicingTrackingIndex - 1].items.push({
                                    text: 'Generate Invoices',
                                    icon: window._env_.REACT_APP_MENU_USE_PNG ? ScreenIcon : 'icon icon-ag-seed-inventory',
                                    path: "/wm/generateinvoices",
                                    permission: null
                                });
                            }
                            if (res.data.hasOwnProperty("WMMenu") && res.data.WMMenu.includes(PermissionsConstants.WMMenuViewUpdateInvoices)) {
                                wmSideBarLinks[wmInvoicingTrackingIndex - 1].items.push({
                                    text: "Update Invoices",
                                    icon: window._env_.REACT_APP_MENU_USE_PNG ? ScreenIcon : 'icon icon-ag-seed-inventory',
                                    path: "/wm/searchinvoices",
                                    permission: null
                                });
                            }
                            if (res.data.hasOwnProperty("WMMenu") && res.data.WMMenu.includes(PermissionsConstants.WMMenuCommitInvoices)) {
                                wmSideBarLinks[wmInvoicingTrackingIndex - 1].items.push({
                                    text: 'Commit Invoices',
                                    icon: window._env_.REACT_APP_MENU_USE_PNG ? ScreenIcon : 'icon icon-ag-seed-inventory',
                                    path: "/wm/commitinvoices",
                                    permission: null
                                });
                            }
                            if (res.data.hasOwnProperty("WMMenu") && res.data.WMMenu.includes(PermissionsConstants.WMMenuViewUndoInvoices)) {
                                wmSideBarLinks[wmInvoicingTrackingIndex - 1].items.push({
                                    text: 'Undo Invoices',
                                    icon: window._env_.REACT_APP_MENU_USE_PNG ? ScreenIcon : 'icon icon-ag-seed-inventory',
                                    path: "/wm/undoinvoices",
                                    permission: null
                                });
                            }
                            if (res.data.hasOwnProperty("WMMenu") && res.data.WMMenu.includes(PermissionsConstants.WMMenuViewSearchCharges)) {
                                wmSideBarLinks[wmChargesTrackingIndex - 1].items.push({
                                    text: 'Enter Charges',
                                    icon: window._env_.REACT_APP_MENU_USE_PNG ? ScreenIcon : 'icon icon-ag-seed-inventory',
                                    path: "/wm/charges/search-charges",
                                    permission: null
                                });
                            }
                            if (res.data.hasOwnProperty("WMMenu") && res.data.WMMenu.includes(PermissionsConstants.WMMenuViewGenerateStorageCharges)) {
                                wmSideBarLinks[wmChargesTrackingIndex - 1].items.push({
                                    text: 'Generate Storage Charges',
                                    icon: window._env_.REACT_APP_MENU_USE_PNG ? ScreenIcon : 'icon icon-ag-seed-inventory',
                                    path: "/wm/charges/generate-storage-charges",
                                    permission: null
                                });
                            }
                            if (res.data.hasOwnProperty("WMMenu") && res.data.WMMenu.includes(PermissionsConstants.WMMenuViewCalculateDeferredRevenue)) {
                                wmSideBarLinks[wmChargesTrackingIndex - 1].items.push({
                                    text: 'Calculate Deferred Handling Revenue',
                                    icon: window._env_.REACT_APP_MENU_USE_PNG ? ScreenIcon : 'icon icon-ag-seed-inventory',
                                    path: "/wm/charges/calculate-deferred-handling-revenue",
                                    permission: null
                                });
                            }
                            if (res.data.hasOwnProperty("WMMenu") && res.data.WMMenu.includes(PermissionsConstants.WMMenuViewUpdateFreeDaysGracePeriods)) {
                                wmSideBarLinks[wmChargesTrackingIndex - 1].items.push({
                                    text: 'Update Free Days and Grace Periods',
                                    icon: window._env_.REACT_APP_MENU_USE_PNG ? ScreenIcon : 'icon icon-ag-seed-inventory',
                                    path: "/wm/charges/update-free-days-grace-periods",
                                    permission: null
                                });
                            }
                            if (res.data.hasOwnProperty("WMMenu") && res.data.WMMenu.includes(PermissionsConstants.WMMenuViewGenerateRepeatingMiscCharges)) {
                                wmSideBarLinks[wmChargesTrackingIndex - 1].items.push({
                                    text: 'Generate Repeating Miscellaneous Charges',
                                    icon: window._env_.REACT_APP_MENU_USE_PNG ? ScreenIcon : 'icon icon-ag-seed-inventory',
                                    path: "/wm/charges/generate-repeating-misc-charges",
                                    permission: null
                                });
                            }
                            if (res.data.hasOwnProperty("WMMenu") && res.data.WMMenu.includes(PermissionsConstants.WMMenuViewTransferShipmentsToDispatch)) {
                                wmSideBarLinks[wmDeliveryManagementIndex - 1].items.push({
                                    text: 'Transfer Shipments To Dispatch',
                                    icon: window._env_.REACT_APP_MENU_USE_PNG ? ScreenIcon : 'icon icon-ag-seed-inventory',
                                    path: "/wm/delivery-management/transfer-shipments-to-dispatch",
                                    permission: null
                                });
                            }
                            // AI8 nests this one level deeper than the other Periodic Tasks entries:
                            // WM > Periodic Tasks > Item Codes > Purge Never Used Items, alongside
                            // Recalculate Item Quantity Status and Set Unused Lots To Inactive Status
                            // (neither migrated yet).
                            //
                            // The "Item Codes" folder is created HERE rather than beside importSection
                            // at build time so it cannot render as an empty folder for a user without the
                            // permission. When a second Item Codes screen is migrated, hoist it to a
                            // named local and have both leaves push into it.
                            //
                            // importSection is the "Periodic Tasks" folder, a named local (line ~425)
                            // still in closure scope here — clearer and less fragile than an index into
                            // wmSideBarLinks, which shifts whenever a folder is added above it.
                            if (res.data.hasOwnProperty("WMMenu") && res.data.WMMenu.includes(PermissionsConstants.WMMenuViewPurgeNeverUsedRecords)) {
                                importSection.items.push({
                                    id: 'wmSideBarLinks_1_2_1',
                                    expanded: false,
                                    icon: 'fa fa-folder',
                                    text: "Item Codes",
                                    items: [{
                                        text: 'Purge Never Used Items, Lots and Sublots',
                                        icon: window._env_.REACT_APP_MENU_USE_PNG ? ScreenIcon : 'icon icon-ag-seed-inventory',
                                        path: "/wm/periodic-tasks/item-codes/purge-never-used-records",
                                        permission: null
                                    }]
                                });
                            }
                            // WMD0068 - Set Unused Lots To Inactive Status. Second leaf of the same
                            // "Item Codes" folder, but deliberately in a block of its own rather than
                            // added to the one above: the two screens are granted separately (this
                            // operation is reversible where a purge is not), so a user may hold either
                            // permission without the other.
                            //
                            // It therefore REUSES the folder when the block above has already created it
                            // and creates it otherwise — looked up by id, so a user holding both
                            // permissions gets one folder with two leaves rather than two folders of the
                            // same name.
                            if (res.data.hasOwnProperty("WMMenu") && res.data.WMMenu.includes(PermissionsConstants.WMMenuViewSetUnusedLotsInactive)) {
                                let wmItemCodes = importSection.items.find((entry) => entry.id === 'wmSideBarLinks_1_2_1');

                                if (!wmItemCodes) {
                                    wmItemCodes = {
                                        id: 'wmSideBarLinks_1_2_1',
                                        expanded: false,
                                        icon: 'fa fa-folder',
                                        text: "Item Codes",
                                        items: []
                                    };
                                    importSection.items.push(wmItemCodes);
                                }

                                wmItemCodes.items.push({
                                    text: 'Set Unused Lots To Inactive Status',
                                    icon: window._env_.REACT_APP_MENU_USE_PNG ? ScreenIcon : 'icon icon-ag-seed-inventory',
                                    path: "/wm/periodic-tasks/item-codes/set-unused-lots-inactive",
                                    permission: null
                                });
                            }
                            // WMD0124 - Delete Item Tasks. AI8 files this under WM > Periodic Tasks >
                            // Transactions, a sibling folder of Item Codes above, so it gets its own
                            // folder rather than joining that one.
                            //
                            // Created on first use for the same reason: no empty folder for a user
                            // without the permission. Looked up by id so a second Transactions screen can
                            // reuse it by repeating this shape.
                            if (res.data.hasOwnProperty("WMMenu") && res.data.WMMenu.includes(PermissionsConstants.WMMenuViewDeleteItemTasks)) {
                                let wmPeriodicTransactions = importSection.items.find((entry) => entry.id === 'wmSideBarLinks_1_2_2');

                                if (!wmPeriodicTransactions) {
                                    wmPeriodicTransactions = {
                                        id: 'wmSideBarLinks_1_2_2',
                                        expanded: false,
                                        icon: 'fa fa-folder',
                                        text: "Transactions",
                                        items: []
                                    };
                                    importSection.items.push(wmPeriodicTransactions);
                                }

                                wmPeriodicTransactions.items.push({
                                    text: 'Delete Item Tasks',
                                    icon: window._env_.REACT_APP_MENU_USE_PNG ? ScreenIcon : 'icon icon-ag-seed-inventory',
                                    path: "/wm/periodic-tasks/transactions/delete-item-tasks",
                                    permission: null
                                });
                            }
                            if (res.data.hasOwnProperty("TransactionReceipt") && res.data.TransactionReceipt.includes(PermissionsConstants.TransactionReceiptViewSchedulingInfo)) {
                                wmSideBarLinks[wmCarrierTrackingIndex - 1].items.push({
                                    text: "Scheduling",
                                    icon: window._env_.REACT_APP_MENU_USE_PNG ? ScreenIcon : 'icon icon-ag-seed-inventory',
                                    path: "/wm/scheduling",
                                    permission: null
                                });
                                 
                            }
                            if (res.data.hasOwnProperty("WMMenu") && res.data.WMMenu.includes(PermissionsConstants.WMCommitTransactions)) {
                                wmSideBarLinks[0].items.push({
                                    text: "Commit Transactions To Inventory",
                                    icon: window._env_.REACT_APP_MENU_USE_PNG ? ScreenIcon : 'icon icon-ag-seed-inventory',
                                    path: "/wm/CommitTransactions",
                                    permission: null
                                });
                            }
                            if (res.data.hasOwnProperty("WMMenu") && res.data.WMMenu.includes(PermissionsConstants.WMUpdateTransactionsStage)) {
                                wmSideBarLinks[0].items.push({
                                    text: "Update Transactions Stage",
                                    icon: window._env_.REACT_APP_MENU_USE_PNG ? ScreenIcon : 'icon icon-ag-seed-inventory',
                                    path: "/wm/UpdateTransactionsStage",
                                    permission: null
                                });
                            }
                            if (res.data.hasOwnProperty("WMMenu") && res.data.WMMenu.includes(PermissionsConstants.WMUnCommitTransactions)) {
                                wmSideBarLinks[0].items.push({
                                    text: 'UnCommit Transactions To Inventory',
                                    icon: window._env_.REACT_APP_MENU_USE_PNG ? ScreenIcon : 'icon icon-ag-seed-inventory',
                                    path: "/wm/uncommittransactions",
                                    permission: null
                                });
                            }

                            if (res.data.hasOwnProperty("WMMenu") && res.data.WMMenu.includes(PermissionsConstants.OwnerShipTransferViewIOT)) {
                                wmSideBarLinks[0].items.push({
                                    text: 'Internal Ownership Transfer',
                                    icon: window._env_.REACT_APP_MENU_USE_PNG ? ScreenIcon : 'icon icon-ag-seed-inventory',
                                    path: "/wm/internalownershiptransfer",
                                    permission: null
                                });
                            }

                            if (res.data.hasOwnProperty("WMMenu") && res.data.WMMenu.includes(PermissionsConstants.TransferLotsToDifferentItems)) {
                                wmSideBarLinks[0].items.push({
                                    text: 'Transfer Lots to Different Items',
                                    icon: window._env_.REACT_APP_MENU_USE_PNG ? ScreenIcon : 'icon icon-ag-seed-inventory',
                                    path: "/wm/transferlotstodifferentitems",
                                    permission: null
                                });
                            }

                            if (res.data.hasOwnProperty("WMMenu") && res.data.WMMenu.includes(PermissionsConstants.TransferSublotsToDifferentItems)) {
                                wmSideBarLinks[0].items.push({
                                    text: 'Transfer Sublots to Different Items',
                                    icon: window._env_.REACT_APP_MENU_USE_PNG ? ScreenIcon : 'icon icon-ag-seed-inventory',
                                    path: "/wm/transfersublotstodifferentitems",
                                    permission: null
                                });
                            }

                            if (res.data.hasOwnProperty("WMMenu") && res.data.WMMenu.includes(PermissionsConstants.AdjustAvailableUnAvailableStatus)) {
                                wmSideBarLinks[wmLocationTrackingIndex - 1].items.push({
                                    id: "wmLocationTrackingIndex_2_4",
                                    text: "Adjust Available Unavailable Status",
                                    path: "/wm/adjustavailableunavailablestatus",
                                    icon: window._env_.REACT_APP_MENU_USE_PNG ? ScreenIcon : 'icon icon-ag-report',
                                    permission: null,
                                });
                            }

                            if (res.data.hasOwnProperty("WMMenu") && res.data.WMMenu.includes(PermissionsConstants.MoveSublotInventoryView)) {
                                wmSideBarLinks[wmLocationTrackingIndex - 1].items.push({
                                    text: "Move Sublot Inventory",
                                    icon: window._env_.REACT_APP_MENU_USE_PNG ? ScreenIcon : 'icon icon-ag-seed-inventory',
                                    path: "/wm/move-sublot-inventory",
                                    permission: null
                                });
                            }

                            if (res.data.hasOwnProperty("WMMenu") && res.data.WMMenu.includes(PermissionsConstants.WarehouseMap)) {
                                wmSideBarLinks[wmLocationTrackingIndex - 1].items.push({
                                    id: "1_7_1",
                                    text: "Map",
                                    path: "/wm/warehouse/map",
                                    icon: window._env_.REACT_APP_MENU_USE_PNG ? ScreenIcon : 'icon icon-ag-report',
                                    permission: null,
                                });
                            }
                            if (res.data.hasOwnProperty("WMMenu") && res.data.WMMenu.includes(PermissionsConstants.LocationManagement)) {
                                wmSideBarLinks[wmLocationTrackingIndex - 1].items.push({
                                    id: "wmLocationTrackingIndex_3_4",
                                    text: "Location Management",
                                    path: "/wm/locationmanagement",
                                    icon: window._env_.REACT_APP_MENU_USE_PNG ? ScreenIcon : 'icon icon-ag-report',
                                    permission: null,
                                });
                            }

                            // Labor Tracking => Enter Labor Tracking.
                            if (res.data.hasOwnProperty("WMMenu") && res.data.WMMenu.includes(PermissionsConstants.EnterLaborTracking)) {
                                wmSideBarLinks[wmLaborTrackingIndex - 1].items.push({
                                    id: "wmLaborTrackingIndex_1",
                                    text: "Enter Labor Tracking",
                                    path: PermissionsConstants.LaborTrackingRoutes.List,
                                    icon: window._env_.REACT_APP_MENU_USE_PNG ? ScreenIcon : 'icon icon-ag-report',
                                    permission: null,
                                });
                            }

                            // WM Transactions (wmSideBarLinks[0]) => Charges => Generate Storage
                            // Charges. Merge into the existing (DB-overlaid) "Charges" folder rather
                            // than creating a duplicate; only build the folder if it is not present.
                            if (res.data.hasOwnProperty("WMMenu") && res.data.WMMenu.includes(PermissionsConstants.WMMenuViewTransactionGenerateStorageCharges)) {
                                const wmTransactionsNode = wmSideBarLinks[0];
                                if (!Array.isArray(wmTransactionsNode.items)) {
                                    wmTransactionsNode.items = [];
                                }
                                let chargesFolder = wmTransactionsNode.items.find(it => it && it.text === "Charges" && Array.isArray(it.items));
                                if (!chargesFolder) {
                                    chargesFolder = {
                                        id: "wmSideBarLinks_0_3_charges",
                                        text: "Charges",
                                        icon: 'fa fa-folder',
                                        expanded: false,
                                        permission: null,
                                        items: [],
                                    };
                                    wmTransactionsNode.items.push(chargesFolder);
                                }
                                chargesFolder.items.push({
                                    id: "wmSideBarLinks_0_3_charges_1",
                                    text: "Generate Storage Charges",
                                    path: PermissionsConstants.TransactionStorageChargesRoute,
                                    icon: window._env_.REACT_APP_MENU_USE_PNG ? ScreenIcon : 'icon icon-ag-seed-inventory',
                                    permission: null,
                                });
                            }

                            // WM Reports (wmSideBarLinks[1]) => Transactions => Query Transactions by Customer.
                            // Merge into the existing (DB-overlaid) "Transactions" folder rather than
                            // creating a duplicate; only build the folder if it is not already present.
                            if (res.data.hasOwnProperty("Reports") && res.data.Reports.includes(PermissionsConstants.ReportsQueryTransactionsByCustomer)) {
                                const wmReportsNode = wmSideBarLinks[1];
                                let txnFolder = (wmReportsNode.items || []).find(it => it && it.text === "Transactions" && Array.isArray(it.items));
                                if (!txnFolder) {
                                    txnFolder = {
                                        id: "wmSideBarLinks_0_8_txn",
                                        text: "Transactions",
                                        icon: 'fa fa-folder',
                                        expanded: false,
                                        permission: null,
                                        items: [],
                                    };
                                    wmReportsNode.items.push(txnFolder);
                                }
                                txnFolder.items.push({
                                    id: "wmSideBarLinks_0_8_txn_1",
                                    text: "Query Transactions by Customer",
                                    path: "/wm/reports/transactionsbycustomer",
                                    icon: window._env_.REACT_APP_MENU_USE_PNG ? ReportTemplateIcon : 'icon icon-ag-report',
                                    permission: null,
                                });
                            }

                            // OM Reports (om_reports_7_1) => Sales Orders => Query Orders By
                            // Customer (legacy OMD0010). Merge into the existing (DB-overlaid)
                            // "Sales Orders" folder rather than creating a duplicate; only build
                            // the folder if it is not already present.
                            if (res.data.hasOwnProperty("OMReports") && res.data.OMReports.includes(PermissionsConstants.OMReportsQueryOrdersByCustomer)) {
                                const omReportsNode = OMSideBarLinks.find(it => it && it.id === 'om_reports_7_1');
                                if (omReportsNode) {
                                    if (!Array.isArray(omReportsNode.items)) {
                                        omReportsNode.items = [];
                                    }
                                    let salesOrdersFolder = omReportsNode.items.find(it => it && it.text === "Sales Order" && Array.isArray(it.items));
                                    if (!salesOrdersFolder) {
                                        salesOrdersFolder = {
                                            id: "om_reports_7_1_so",
                                            text: "Sales Order",
                                            icon: 'fa fa-folder',
                                            expanded: false,
                                            permission: null,
                                            items: [],
                                        };
                                        omReportsNode.items.push(salesOrdersFolder);
                                    }
                                    // First item in the folder, matching OM.xml where
                                    // "Query Orders By Customer" is the first entry under
                                    // Reports => Sales Orders.
                                    salesOrdersFolder.items.unshift({
                                        id: "om_reports_7_1_so_1",
                                        text: "Query Orders By Customer",
                                        path: "/om/reports/query-orders-by-customer",
                                        icon: window._env_.REACT_APP_MENU_USE_PNG ? ReportTemplateIcon : 'icon icon-ag-report',
                                        permission: null,
                                    });
                                }
                            }

                            // if (res.data.hasOwnProperty("WMMenu")) {
                            //     var warehouseSection =
                            //     {
                            //         id: 'wmSideBarLinks_1_6',
                            //         expanded: false,
                            //         icon: 'fa fa-folder',
                            //         text: "Warehouse",
                            //         items: []
                            //     }

                            //     wmSideBarLinks.push(warehouseSection);

                            //     if (res.data.WMMenu.includes(PermissionsConstants.WarehouseMap)) {
                            //         warehouseSection.items.push({
                            //             id: "1_7_1",
                            //             text: "Map",
                            //             path: "/wm/warehouse/map",
                            //             icon: window._env_.REACT_APP_MENU_USE_PNG ? ScreenIcon : 'icon icon-ag-report',
                            //             permission: null,
                            //         });
                            //     }
                            // }

                            wmSideBarLinks.map((link, i) => {

                                let sidebar = {};
                                sidebar.id = link.id;
                                sidebar.text = link.text;
                                sidebar.icon = link.icon;
                                sidebar.items = [];

                                var tFlag = false;
                                link.items.map((item, i) => {
                                    if (item.permission == null) {
                                        sidebar.items.push(item);
                                    }
                                    else {
                                        for (let key in res.data) {
                                            if (key.includes(item.permission) && item.permission == "Transaction" && tFlag == false) {
                                                sidebar.items.push(item);
                                                tFlag = true;
                                            }
                                            else if (key.includes(item.permission) && item.permission != "Transaction") {
                                                sidebar.items.push(item);
                                            }
                                        }
                                    }
                                });
                                if (sidebar.items.length > 0) {
                                    wmSidebar.push(sidebar);
                                }
                            });
                            
                            rfSideBarLinks.map((link, i) => {

                                let sidebar = {};
                                sidebar.id = link.id;
                                sidebar.text = link.text;
                                sidebar.icon = link.icon;
                                sidebar.items = [];

                                var tFlag = false;
                                link.items.map((item, i) => {
                                    if (item.permission == null) {
                                        sidebar.items.push(item);
                                    }
                                    else {
                                        for (let key in res.data) {
                                            if (key.includes(item.permission) && item.permission == "Transaction" && tFlag == false) {
                                                sidebar.items.push(item);
                                                tFlag = true;
                                            }
                                            else if (key.includes(item.permission) && item.permission != "Transaction") {
                                                sidebar.items.push(item);
                                            }
                                        }
                                    }
                                });
                                if (sidebar.items.length > 0) {
                                    rfSidebar.push(sidebar);
                                }
                            });

                            let efSidebar = [];
                            efSideBarLinks.forEach((link) => {
                                if (link.permission == null) {
                                    // Leaf link (no items property) → always include.
                                    // Parent folder (items array) → include only if it has at least one child.
                                    if (link.items === undefined) {
                                        efSidebar.push(link);
                                    } else if (link.items.length > 0) {
                                        efSidebar.push(link);
                                    }
                                } else {
                                    for (let key in res.data) {
                                        if (Array.isArray(res.data[key]) && res.data[key].includes(link.permission)) {
                                            efSidebar.push(link);
                                            break;
                                        }
                                    }
                                }
                            });

                            let acSidebar = [];
                            acSideBarLinks.forEach((link) => {
                                if (link.permission == null) {
                                    if (link.items === undefined) {
                                        acSidebar.push(link);
                                    } else if (link.items.length > 0) {
                                        acSidebar.push(link);
                                    }
                                } else {
                                    for (let key in res.data) {
                                        if (Array.isArray(res.data[key]) && res.data[key].includes(link.permission)) {
                                            acSidebar.push(link);
                                            break;
                                        }
                                    }
                                }
                            });

                            // Build the filtered sidebar for each simple (data-driven) module.
                            // Stores the result on the module entry under .sidebar so the later
                            // treeviewArray push can iterate the same list.
                            simpleModuleDefinitions.forEach((m) => {
                                const result = [];
                                m.sideBarLinks.forEach((link) => {
                                    if (link.permission == null) {
                                        if (link.items === undefined) {
                                            result.push(link);
                                        } else if (link.items.length > 0) {
                                            result.push(link);
                                        }
                                    } else {
                                        for (let key in res.data) {
                                            if (Array.isArray(res.data[key]) && res.data[key].includes(link.permission)) {
                                                result.push(link);
                                                break;
                                            }
                                        }
                                    }
                                });
                                m.sidebar = result;
                            });
                            // setWMMainMenu(wmSidebar);
                            // setSecurityMainMenu(securitySidebar);

                            let atSidebar = [];

                            atSideBarLinks.map((link) => {
                                if (link.permission == null) {
                                    if (link.items && link.items.length > 0) {
                                        atSidebar.push(link);
                                    }
                                } else if (res?.data?.ATMenu?.includes(link.permission)) {
                                    atSidebar.push(link);
                                }
                            });

                            let treeviewArray = [];

                            if (atSidebar.length > 0) {
                                treeviewArray.push({
                                    id: 'at_3',
                                    text: 'Advanced Reporting Tool',
                                    icon: window._env_.REACT_APP_MENU_USE_PNG ? ReportIcon : 'fa fa-folder',
                                    orderNumber: GetMenuOrder(menuList, MenuNames.AdvancedReportingTool),
                                    expanded: false,
                                    items: atSidebar
                                });
                            }


                            let dockdoorSidebar = [];
                            dockdoorSideBarLinks.map((link) => {

                                if (res?.data?.DockDoor?.includes(link.permission)) {
                                    dockdoorSidebar.push(link);
                                }
                                else if (link.items && link.items.length > 0) {
                                    let lnks = link.items.filter(el => el.permission == null);
                                    if (lnks.length) {
                                        dockdoorSidebar.push({
                                            id: link.id,
                                            text: link.text,
                                            icon: link.icon,
                                            expanded: link.expanded,
                                            path: link.path,
                                            items: lnks
                                        });
                                    }
                                }
                            });

                            if (dockdoorSidebar.length > 0) {
                                treeviewArray.push({
                                    id: 'DD_1',
                                    text: 'Dock Door Scheduler',
                                    icon: window._env_.REACT_APP_MENU_USE_PNG ? DockDoorIcon : 'fa fa-folder',
                                    orderNumber: GetMenuOrder(menuList, MenuNames.DockDoorScheduler),
                                    expanded: false,
                                    items: dockdoorSidebar,
                                });
                            }
                            if (xmSidebar.length > 0) {
                                treeviewArray.push({
                                    id: 'xm_99',
                                    text: 'Import/Export Data',
                                    icon: window._env_.REACT_APP_MENU_USE_PNG ? ImportExportIcon : 'fa fa-folder',
                                    orderNumber: 99,
                                    expanded: false,
                                    items: xmSidebar,
                                });
                            }
                             if (taskAgentSidebar.length > 0) {
                                treeviewArray.push({
                                    id: 'task_99',
                                    text: 'Task Agent',
                                    icon: window._env_.REACT_APP_MENU_USE_PNG ? ImportExportIcon : 'fa fa-folder',
                                    orderNumber: 99,
                                    expanded: false,
                                    items: taskAgentSidebar,
                                });
                            }
                            if (securitySidebar.length > 0) {
                                treeviewArray.push({
                                    id: 'security_99',
                                    text: 'Security',
                                    icon: window._env_.REACT_APP_MENU_USE_PNG ? SecurityIcon : 'fa fa-folder',
                                    orderNumber: 100,
                                    expanded: false,
                                    items: securitySidebar,
                                });
                            }

                            if (sodSidebarMain.length > 0) {
                                treeviewArray.push({
                                    id: 'sod_2',
                                    text: 'Sow Order Database',
                                    orderNumber: GetMenuOrder(menuList, MenuNames.SowOrderDatabase),
                                    icon: window._env_.REACT_APP_MENU_USE_PNG ? SodIcon : 'fa fa-folder',
                                    expanded: false,
                                    items: sodSidebarMain,
                                });
                            }
                            var dashboardSideBarLinks = [
                                {
                                    id: "dashboard_1_1",
                                    text: "Manage",
                                    icon: window._env_.REACT_APP_MENU_USE_PNG ? ScreenIcon : 'icon icon-ag-report', 
                                    path: "/dbl/management",
                                    permission: PermissionsConstants.ManageDashboard,
                                },
                                {
                                    id: 'dashboard_1_2',
                                    text: 'Configuration',
                                    icon: window._env_.REACT_APP_MENU_USE_PNG ? ScreenIcon : 'icon icon-ag-report', 
                                    expanded: false,
                                    path: "/dbl/configuration",
                                    permission: PermissionsConstants.DashboardConfiguration

                                }
                            ]

                             
                            /////////// Add PTR Menu////////////////////
                            const PTRMenuPermissions = res?.data?.PTRMenu || [];
                            console.log("PTRMenuPermissions" + PTRMenuPermissions);
                            const ptrSideBarLinks = [
                                {
                                    id: "ptr_1_1",
                                    text: "Dashboard",
                                    icon: window._env_.REACT_APP_MENU_USE_PNG ? ScreenIcon : 'icon icon-ag-report',  
                                    path: "/ptr/LoadIframe/" + PermissionsConstants.DashboardManagement,
                                    permission: PermissionsConstants.DashboardManagement,
                                },
                                {
                                    id: "ptr_1_2",
                                    text: "Early Tag Report",
                                    icon: window._env_.REACT_APP_MENU_USE_PNG ? ScreenIcon : 'icon icon-ag-report', 
                                    path: "/ptr/LoadIframe/" + PermissionsConstants.EarlyTagReport,
                                    permission: PermissionsConstants.EarlyTagReport,
                                },
                                {
                                    id: "ptr_1_3",
                                    text: "Daily Updates",
                                    icon: window._env_.REACT_APP_MENU_USE_PNG ? ScreenIcon : 'icon icon-ag-report', 
                                    path: "/ptr/LoadIframe/" + PermissionsConstants.PTRDailyUpdates,
                                    permission: PermissionsConstants.PTRDailyUpdates,
                                },
                                {
                                    id: "ptr_1_4",
                                    text: "Daily Updates (BETA)",
                                    icon: window._env_.REACT_APP_MENU_USE_PNG ? ScreenIcon : 'icon icon-ag-report', 
                                    path: "/ptr/LoadIframe/" + PermissionsConstants.PTRDailyUpdates2,
                                    permission: PermissionsConstants.PTRDailyUpdates2,
                                },
                                {
                                    id: "ptr_1_5",
                                    text: "Master Codes",
                                    icon: window._env_.REACT_APP_MENU_USE_PNG ? ScreenIcon : 'icon icon-ag-report', 
                                    path: "/ptr/LoadIframe/" + PermissionsConstants.PTRConfiguration,
                                    permission: PermissionsConstants.PTRConfiguration,
                                },
                                {
                                    id: "ptr_1_6",
                                    text: "Group Overrides",
                                    icon: window._env_.REACT_APP_MENU_USE_PNG ? ScreenIcon : 'icon icon-ag-report', 
                                    path: "/ptr/LoadIframe/" + PermissionsConstants.PTROverrides,
                                    permission: PermissionsConstants.PTROverrides,
                                },
                                {
                                    id: "ptr_1_7",
                                    text: "Attributes",
                                    icon: window._env_.REACT_APP_MENU_USE_PNG ? ScreenIcon : 'icon icon-ag-report', 
                                    path: "/ptr/LoadIframe/" + PermissionsConstants.PTRAttributes,
                                    permission: PermissionsConstants.PTRAttributes,
                                },
                                {
                                    id: "ptr_1_8",
                                    text: "Rules",
                                    icon: window._env_.REACT_APP_MENU_USE_PNG ? ScreenIcon : 'icon icon-ag-report', 
                                    path: "/ptr/LoadIframe/" + PermissionsConstants.PTRRules,
                                    permission: PermissionsConstants.PTRRules,
                                },
                                {
                                    id: "ptr_1_9",
                                    text: "Crop Roll Tool",
                                    icon: window._env_.REACT_APP_MENU_USE_PNG ? ScreenIcon : 'icon icon-ag-report', 
                                    path: "/ptr/LoadIframe/" + PermissionsConstants.PTRCropRollTool,
                                    permission: PermissionsConstants.PTRCropRollTool,
                                }
                            ];
                            const ptrSidebar = menueService.createSidebar(ptrSideBarLinks, PTRMenuPermissions);
                            if (ptrSidebar.length > 0) {
                                treeviewArray.push({
                                    id: 'ptr_1',
                                    text: 'Pull Tag Review',
                                    icon: window._env_.REACT_APP_MENU_USE_PNG ? PtrIcon : 'fa fa-folder',
                                    orderNumber: GetMenuOrder(menuList, MenuNames.PullTagReview),
                                    expanded: false,
                                    items: ptrSidebar,
                                });
                            }
                            if (poSidebar.length > 0) {
                                treeviewArray.push({
                                    id: 'po_1',
                                    text: 'Purchase Order Management',
                                    icon: window._env_.REACT_APP_MENU_USE_PNG ? ImportExportIcon : 'fa fa-folder',
                                    orderNumber: GetMenuOrder(menuList, MenuNames.PurchaseOrderManagement),
                                    expanded: false,
                                    items: poSidebar,
                                });
                            }
                            /////////// Add PTR Menu////////////////////
                            /////////// Add Dashboard Menu////////////////////
                            const DBMenuPermissions = res?.data?.DBMenu || [];
                            const devexpressDashboardSideBarLinks = [
                                {
                                    id: "devexpressDashboard_1_2",
                                    text: "Manage Datasource",
                                    icon: window._env_.REACT_APP_MENU_USE_PNG ? ScreenIcon : 'icon icon-ag-report', 
                                    path: "/db/searchdatasource",
                                    permission: PermissionsConstants.SearchDatasourceQuery,
                                },
                                {
                                    id: "devexpressDashboard_1_3",
                                    text: "Configure Datasource",
                                    icon: window._env_.REACT_APP_MENU_USE_PNG ? ScreenIcon : 'icon icon-ag-report', 
                                    path: "/db/datasourceconfiguration",
                                    permission: PermissionsConstants.DataSourceConfiguration,
                                },
                                {
                                    id: "devexpressDashboard_1_1",
                                    text: "Design Dashboard",
                                    icon: window._env_.REACT_APP_MENU_USE_PNG ? ScreenIcon : 'icon icon-ag-report',
                                    path: "/db/ManageDashboard",
                                    permission: PermissionsConstants.ManageDataSource,
                                },
                                {
                                    id: "devexpressDashboard_1_5",
                                    text: "Copy Dashboard",
                                    icon: window._env_.REACT_APP_MENU_USE_PNG ? ScreenIcon : 'icon icon-ag-report',
                                    path: "/db/CopyDashboard",
                                    permission: PermissionsConstants.ManageDataSource,
                                },
                                {
                                    id: "devexpressDashboard_1_6",
                                    text: "Export Dashboard",
                                    icon: window._env_.REACT_APP_MENU_USE_PNG ? ScreenIcon : 'icon icon-ag-report',
                                    path: "/db/ExportDashboard",
                                    permission: PermissionsConstants.ManageDataSource,
                                },
                                {
                                    id: "devexpressDashboard_1_7",
                                    text: "Import Dashboard",
                                    icon: window._env_.REACT_APP_MENU_USE_PNG ? ScreenIcon : 'icon icon-ag-report',
                                    path: "/db/ImportDashboard",
                                    permission: PermissionsConstants.ManageDataSource,
                                },
                                {
                                    id: "devexpressDashboard_1_4",
                                    text: "Configure Dashboard",
                                    icon: window._env_.REACT_APP_MENU_USE_PNG ? ScreenIcon : 'icon icon-ag-report',
                                    path: "/db/dashboardconfiguration",
                                    permission: PermissionsConstants.DevexpressDashboardConfiguration,
                                }
                            ];
                            const devexpressDashboardSidebar = menueService.createSidebar(devexpressDashboardSideBarLinks, DBMenuPermissions);
                            if (devexpressDashboardSidebar.length > 0) {
                                treeviewArray.push({
                                    id: 'devexpressDashboard_1',
                                    text: 'Dashboard',
                                    icon: window._env_.REACT_APP_MENU_USE_PNG ? DashboardIcon : 'fa fa-folder',
                                    orderNumber: GetMenuOrder(menuList, MenuNames.Dashboard),
                                    expanded: false,
                                    items: devexpressDashboardSidebar,
                                });
                            }
                            /////////// Add PTR Menu////////////////////
                            let dashboardSidebar = [];

                            dashboardSideBarLinks.map((link) => {
                                if (res?.data?.DBLMenu?.includes(link.permission)) {
                                    dashboardSidebar.push(link);
                                }
                            });



                            if (dashboardSidebar.length > 0) {
                                treeviewArray.push({
                                    id: 'dashboard_1',
                                    text: 'Dashboard Lite',
                                    icon: window._env_.REACT_APP_MENU_USE_PNG ? DashboardLiteIcon : 'fa fa-folder',
                                    orderNumber: GetMenuOrder(menuList, MenuNames.DashboardLite),
                                    expanded: false,
                                    items: dashboardSidebar
                                });
                            }

                            let imSidebar = [];
                            IM_SideBarLinks.map((link) => {
                                let lnks = link.items.filter(el => el.permission == null || (res?.data?.IMMenu?.includes(el.permission)) || (res?.data?.IMReports?.includes(el.permission)));
                                if (lnks.length) {
                                    let sidebar = {};
                                    sidebar.id = link.id;
                                    sidebar.text = link.text;
                                    sidebar.icon = "fa fa-folder";
                                    sidebar.items = lnks;
                                    imSidebar.push(sidebar);
                                }
                            });

                            if (imSidebar.length > 0) {

                                treeviewArray.push({
                                    id: 'im_1',
                                    text: 'Inventory Management',
                                    icon: window._env_.REACT_APP_MENU_USE_PNG ? OmIcon : 'fa fa-folder',
                                    orderNumber: GetMenuOrder(menuList, MenuNames.InventoryManagement),
                                    expanded: false,
                                    items: imSidebar,
                                });
                            }
                            let omSidebar = [];
                            const omPermissionListIncludes = (listKey, permission) => {
                                const list = res?.data?.[listKey];
                                return Array.isArray(list) && list.includes(permission);
                            };
                            const omSidebarItemAllowed = (el) => {
                                if (el == null) return false;
                                if (el.permission == null) return true;
                                const p = el.permission;
                                return omPermissionListIncludes('OMMenu', p)
                                    || omPermissionListIncludes('OMReports', p)
                                    || omPermissionListIncludes('Setup', p)
                                    || omPermissionListIncludes('DataProfiles', p)
                                    || omPermissionListIncludes('OMCodes', p);
                            };
                            const filterOMSidebarNestedItems = (items) => {
                                if (!Array.isArray(items) || items.length === 0) return [];
                                const out = [];
                                for (const el of items) {
                                    if (el == null) continue;
                                    const childItems = el.items;
                                    if (Array.isArray(childItems) && childItems.length > 0) {
                                        const nested = filterOMSidebarNestedItems(childItems);
                                        if (nested.length > 0) {
                                            out.push({ ...el, items: nested });
                                        }
                                    } else if (omSidebarItemAllowed(el)) {
                                        out.push(el);
                                    }
                                }
                                return out;
                            };
                            OMSideBarLinks.map((link) => {
                                let lnks = filterOMSidebarNestedItems(link.items || []);
                                if (lnks.length) {
                                    let sidebar = {};
                                    sidebar.id = link.id;
                                    sidebar.text = link.text;
                                    sidebar.icon = "fa fa-folder";
                                    sidebar.items = lnks;
                                    omSidebar.push(sidebar);
                                }
                            });

                            if (omSidebar.length > 0) {

                                treeviewArray.push({
                                    id: 'om_1',
                                    text: 'Order Management',
                                    icon: window._env_.REACT_APP_MENU_USE_PNG ? OmIcon : 'fa fa-folder',
                                    orderNumber: GetMenuOrder(menuList, MenuNames.OrderManagement),
                                    expanded: false,
                                    items: omSidebar,
                                });
                            }
                            if (tmSidebarMain.length > 0) {
                                treeviewArray.push({
                                    id: 'tm_7',
                                    text: 'Orchard Management',
                                    icon: window._env_.REACT_APP_MENU_USE_PNG ? OrchardIcon : 'fa fa-folder',
                                    orderNumber: GetMenuOrder(menuList, MenuNames.OrchardManagement),
                                    expanded: false,
                                    items: tmSidebarMain,
                                });
                            }
                            if (wmSidebar.length > 0) {
                                wmSidebar.sort((a, b) => {
                                    const aIsDashboard = a.id.startsWith('Dashboard_') || a.id.startsWith('ArtReports_');
                                    const bIsDashboard = b.id.startsWith('Dashboard_') || b.id.startsWith('ArtReports_');
                                    if (aIsDashboard && !bIsDashboard) return 1;
                                    if (!aIsDashboard && bIsDashboard) return -1;
                                    return a.id.localeCompare(b.id);
                                });
                                treeviewArray.push({
                                    id: "wm_1",
                                    text: "Warehouse Management",
                                    icon: window._env_.REACT_APP_MENU_USE_PNG ? WmIcon : 'fa fa-folder',
                                    orderNumber: GetMenuOrder(menuList, MenuNames.WarehouseManagement),
                                    expanded: false,
                                    items: wmSidebar
                                });
                            }
                            if (rfSidebar.length > 0) {
                                treeviewArray.push({
                                    id: "rf_1",
                                    text: "Radio Frequency",
                                    icon: window._env_.REACT_APP_MENU_USE_PNG ? DockDoorIcon : 'fa fa-folder',
                                    orderNumber: GetMenuOrder(menuList, MenuNames.RadioFrequency),
                                    expanded: false,
                                    items: rfSidebar
                                });
                            }
                            if (efSidebar.length > 0) {
                                treeviewArray.push({
                                    id: "ef_1",
                                    text: "Equipment and Facilities Management",
                                    icon: window._env_.REACT_APP_MENU_USE_PNG ? DockDoorIcon : 'fa fa-folder',
                                    orderNumber: GetMenuOrder(menuList, MenuNames.ElectronicFrequency),
                                    expanded: false,
                                    items: efSidebar
                                });
                            }
                            if (acSidebar.length > 0) {
                                treeviewArray.push({
                                    id: "ac_1",
                                    text: "Accounting Module",
                                    icon: window._env_.REACT_APP_MENU_USE_PNG ? DockDoorIcon : 'fa fa-folder',
                                    orderNumber: GetMenuOrder(menuList, MenuNames.AccountingModule),
                                    expanded: false,
                                    items: acSidebar
                                });
                            }

                            // Push the 18 simple modules to the treeview using the same icon as RF.
                            simpleModuleDefinitions.forEach((m) => {
                                if (m.sidebar && m.sidebar.length > 0) {
                                    treeviewArray.push({
                                        id: `${m.code.toLowerCase()}_1`,
                                        text: m.displayName,
                                        icon: window._env_.REACT_APP_MENU_USE_PNG ? DockDoorIcon : 'fa fa-folder',
                                        orderNumber: GetMenuOrder(menuList, MenuNames[m.menuNameKey]),
                                        expanded: false,
                                        items: m.sidebar
                                    });
                                }
                            });

                            // Every VISIBLE module shows its Reports node, even when the DB has no
                            // report rows for it yet. A module builder drops the node when it ends
                            // up empty (no rows, or everything permission-gated) — re-add it as an
                            // empty folder. A module with nothing else visible stays hidden: the
                            // empty Reports folder alone never forces a module into the menu.
                            moduleMenuConfigs.forEach((m) => {
                                const moduleEntry = treeviewArray.find(t => t.id === m.treeId);
                                if (!moduleEntry || !Array.isArray(moduleEntry.items) || moduleEntry.items.length === 0) return;
                                const children = moduleEntry.items;
                                if (children.some(n => n.id === m.reportsNodeId)) return;
                                // Only an empty shell is re-added: any report the role can see
                                // would have kept the node in the built sidebar already.
                                const emptyReports = { id: m.reportsNodeId, text: 'Reports', icon: 'fa fa-folder', expanded: false, items: [] };
                                const dashIdx = children.findIndex(n => typeof n.id === 'string' && (n.id.startsWith('Dashboard_') || n.id.startsWith('ArtReports_')));
                                if (dashIdx >= 0) children.splice(dashIdx, 0, emptyReports);
                                else children.push(emptyReports);
                            });

                            treeviewArray.push({
                                id: "logout_1",
                                text: "Logout",
                                tooltip: "Logout",
                                icon: window._env_.REACT_APP_MENU_USE_PNG ? LogoutIcon : 'fa fa-sign-out',
                                orderNumber: 101,
                                expanded: false,
                                path: "/",
                                items: null
                            });
                            var newtreeviewData = treeviewData.slice(0, -1);
                            let sortedArray = [...newtreeviewData, ...treeviewArray];
                            sortedArray = sortedArray.sort((a, b) => {
                                if (a.orderNumber < b.orderNumber) {
                                    return -1;
                                }
                                if (a.orderNumber > b.orderNumber) {
                                    return 1;
                                }
                                return 0;
                            });
                            
                            // Filter out restricted pages from tree view
                            sortedArray = filterRestrictedPages(sortedArray);
                            
                            setTreeviewData(sortedArray);
                        })
                        .catch((err) => {
                            console.log(err, "Error getting ART Reports data");
                        });
                     
                    resolve("ok");
                })
                .catch((err) => {
                    console.log(err, "error");
                    reject(err);
                });
        })
    };
    const generateUniqueId = () => `id_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
    const addUniqueIdsToItems = (items) => {
        return items.map(item => {
            return {
                ...item,
                id: generateUniqueId()
            };
        });
    };
    const addItemsToShortcuts = (newItems) => {
        setTreeviewData(prevData => {
            const filteredNewItems = filterRestrictedPages(newItems);
            return prevData.map(item => {
                if (item.id === "shortcuts_1") {
                    // Replace existing items with new items (filtered)
                    return {
                        ...item,
                        items: [...filteredNewItems]  // Replace items with the filtered new list
                    };
                }
                return item; // Return other items unchanged
            });
        });
    };
    
    // Extract URLs whenever treeviewData changes and store in Redux
    useEffect(() => {
        if (treeviewData && treeviewData.length > 0) {
            const visibleUrls = extractUrlsFromTreeView(treeviewData);
            dispatch(SET_TREEVIEW_VISIBLE_URLS(visibleUrls));
        }
    }, [treeviewData, dispatch]);

    const fetchDashboardMenuData = () => {
        return new Promise(async (resolve, reject) => {
            try {
                 const resp = await axios.post(
                `${window._env_.REACT_APP_APIS}/dbl/Configuration/GetDashboardMenu`,
                {},
                {
                        headers: {
                            "Content-Type": "application/json",
                            access_token: accessToken,
                            Authorization: `Bearer ${accessToken}`,
                            IsAllDashboards: true
                        }
                    }
                );

                for (var i = 0; i < resp.data.length; i++) {
                    const dbItem = resp.data[i];
                    if (dbItem.moduleslist != null && dbItem.webrole != null
                        && props.oidc.user.profile.role != null && dbItem.webrole.includes(props.oidc.user.profile.role)) {
                        const isLite = dbItem.type === 2;
                        moduleMenuConfigs.forEach((m) => {
                            if (dbItem.moduleslist.includes(m.code)) {
                                const targetIndex = isLite ? m.dashboardLiteIndex : m.dashboardIndex;
                                const path = isLite
                                    ? "/dbl/management/viewdashboard/" + dbItem.layoutname
                                    : `/db/ViewDashboard?rowid=${dbItem.rowid}`;
                                m.sideBarLinks[targetIndex - 1].items.push({
                                    text: dbItem.layoutname,
                                    icon: window._env_.REACT_APP_MENU_USE_PNG ? ReportTemplateIcon : 'fa fa-dashboard',
                                    path,
                                    permission: null
                                });
                            }
                        });
                    }
                }
    
                resolve("ok");
            } catch (error) {
                reject(error);
            }
        });
    };
    
    const logoutUser = (e) => {

        var userManager = ReduxOidc.createUserManager(configuration.config);

        var id_token = props.oidc.user.id_token;
        var post_logout_redirect_uri = configuration.config.post_logout_redirect_uri;
        var userState = props.oidc.user?.state;

        // Clear chat messages for all users on logout
        clearAllChatMessages();

        // Clear every list page's remembered search so criteria never cross user sessions
        clearAllSearchStates();

        // Clear tab selection sessionStorage
        sessionStorage.removeItem('wm_selectedTabIndex');
        sessionStorage.removeItem('wm_history_selectedTabIndex');
        sessionStorage.removeItem('wm_inventory_selectedTabIndex');

        // remove cookies
        delete_cookie(".AspNetCore.Identity.Application");
        delete_cookie("idsrv.session");

        userManager.signoutRedirect({
            id_token_hint: id_token,
            post_logout_redirect_uri: post_logout_redirect_uri,
            state: userState
        }).then(() => {
            if (props.oidc.user.profile.hasOwnProperty("LOGINTYPEID") && props.oidc.user.profile.LOGINTYPEID == ABECASUSER_LOGIN_TYPE) {
                axios.post(`${window._env_.REACT_APP_AUTH_URL}/${data.idp.EndLicenseServerSession}`, { Id: props.oidc.user.profile.sub });
            }
        }).catch((error) => {
            console.error(error);
        });
    }

    return (
        <div>
            <div className="form" id="sidebarContent">
                {/* <TrasactionIcon /> */}
                <LoadPanel
                    shadingColor="rgba(0,0,0,0.4)"
                    visible={loadingSidebar}
                    showIndicator={true}
                    shading={false}
                    showPane={true}
                    hideOnOutsideClick={false}
                    position={position}
                />
                <TreeView
                    ref={treeViewRef}
                    id="treeview"
                    items={treeviewData}
                    className="TreeViewStyle"
                    onItemClick={selectItem}
                    onItemContextMenu={treeViewItemContextMenu}
                    expandEvent='click'
                    iconExpr="icon" />
                <ContextMenu
                    ref={contextMenuRef}
                    dataSource={menuItems}
                    target="#treeview .dx-treeview-item"
                    onItemClick={contextMenuItemClick}
                />

                {/* {currentItem.price
                    && <div id="product-details">
                        <img src={currentItem.image} />
                        <div className="name">{currentItem.text}</div>
                        <div className="price">{`$${currentItem.price}`}</div>
                    </div>
                } */}
                {/* <NavLink to="#" activeClassName="" className="sidebarLink transaction">
                    <button
                        onClick={() => logoutUser("logout")}>
                        <span className="linkText" style={{ fontWeight: "bold" }}>
                            Log Out
                        </span>
                    </button>{" "}
                </NavLink> */}
            </div>
        </div>
    );
};

function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}
export default connect(mapStateToProps)(TreeviewSidebar);
